<template>
  <div id="BSC" class="vx-row" oncontextmenu="return false">
    <left-preview-slider v-if="isShowComment" v-on:click="isOpenPreview = $event"></left-preview-slider>
    <Transition name="baikei-transition">
    <div class="vx-col md:w-1/3 mb-base" v-if="isOpenPreview && isShowComment">
      <vx-card title="BSC Preview">
        <img src="@/assets/images/baikei/screen-edit/bsc/bsc-01.jpg" width="100%" v-if="bscPattern == 'bsc-01'" />
        <img src="@/assets/images/baikei/screen-edit/bsc/bsc-02.jpg" width="100%" v-if="bscPattern == 'bsc-02'" />
        <img src="@/assets/images/baikei/screen-edit/bsc/bsc-03.jpg" width="100%" v-if="bscPattern == 'bsc-03'" />
      </vx-card>
    </div>
    </Transition>
    <div class="vx-col mr-7 select flex-grow-width-make" :class="[!isShowComment && !isOpenPreview ? 'w-full' : !isShowComment ? 'w-57' : 'w-65']">
      <!-- start bsc-03  -->
      <vx-card class="preview-edit-screen"  :title="bscPattern" >
        <div v-if="bscPattern === 'bsc-02'" :id="`${arrayCommentId[0]}`">
          <table>
            <tr>
              <td colspan="2">
                <div class="flex-row">
                <div class="flex">
                  <div class="w-2/3">
                    <span class="ml-5">
                      建物の構造耐力上主要な部分等の状況について確認した事項
                    </span>
                    <span class="ml-6"> 既存の住宅に </span>
                  </div>
                  <div>
                    <radio-box @input="lostFocus" class="ml-4"
                              v-model="kozotairyoku_kakuninjiko"
                              vs-name="kozotairyoku_kakuninjiko"
                              vs-value="0"
                              @change="handleCheck('kozotairyoku_kakuninjiko')">該当する</radio-box>
                    <radio-box @input="lostFocus" class="ml-4"
                              v-model="kozotairyoku_kakuninjiko"
                              vs-name="kozotairyoku_kakuninjiko"
                              vs-value="1"
                              @change="handleCheck('kozotairyoku_kakuninjiko')">該当しない</radio-box>
                    <div class="text-warning" style="padding-left:15px" v-if="formValidation.kozotairyoku_kakuninjiko.isWarning">{{formValidation.kozotairyoku_kakuninjiko.warningMsg}}</div>
                  </div>
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <td class="w-2/3">
                <p class="ml-4">
                  「建物の構造耐力上主要な部分」または「雨水の浸入を防止する部分」の状況について建物状況調査により売主、買主の双方が確認した事項
                </p>
              </td>
              <td>
                <div class="flex-row">
                <div class="flex" >
                  <radio-box @input="lostFocus" class="ml-8"
                            v-model="kainushi_urinushi_soho_kakuninjiko"
                            vs-name="kainushi_urinushi_soho_kakuninjiko"
                            vs-value="0" :disabled="kozotairyoku_kakuninjiko!=0">有</radio-box>
                  <radio-box @input="lostFocus" class="ml-8"
                            v-model="kainushi_urinushi_soho_kakuninjiko"
                            vs-name="kainushi_urinushi_soho_kakuninjiko"
                            vs-value="1" :disabled="kozotairyoku_kakuninjiko!=0"
                            >無</radio-box>
                </div>
                <div class="text-warning ml-8" v-if="formValidation.kainushi_urinushi_soho_kakuninjiko.isWarning">{{formValidation.kainushi_urinushi_soho_kakuninjiko.warningMsg}}</div>
                </div>
              </td>
            </tr>
          </table>

          <div>
            <table class="w-full">
              <tr>
                <td rowspan="4" class="w-1/4">
                  <div class="flex">
                    <span class="text-center">「以下余白」の表示</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="flex items-center">
                    <vs-checkbox v-model="kainushi_urinushi_soho_kakuninjiko_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">末尾に「以下余白」を表示する</span>
                  </div>
                </td>
              </tr>
            </table>
            <table class="w-full">
              <tr>
                <td rowspan="4" class="w-1/4">
                  <div class="flex">
                    <span class="text-center">黒点／ナンバリング表示</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="flex items-center">
                    <vs-checkbox v-model="kainushi_urinushi_soho_kakuninjiko_numbering" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">黒点／ナンバリングを表示する</span>
                  </div>
                </td>
              </tr>
            </table>
            <draggable v-model="kainushi_urinushi_soho_kakuninjiko_bikoInputs" handle=".handle">
              <table class="w-full" v-for="(kainushi, index) in kainushi_urinushi_soho_kakuninjiko_bikoInputs" :key="`note-${index}`">
                    <tr>
                      <td rowspan="4" class="w-1/4">
                        <div class="flex">
                          <vs-checkbox @input="lostFocus" v-model="kainushi.checkboxDelete" class="inline-flex"></vs-checkbox>
                          <span class="p-3">備考 {{ index + 1 }} </span>
                          <div class="handle pt-3 pl-3 cursor-default w-27">
                          <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                            <DragBlackIcon />
                          </vx-tooltip>
                        </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="flex items-center">
                          <!-- bsc-02 -->
                          <BunshoTemplate v-model="kainushi.kainushi_urinushi_soho_kakuninjiko_biko" screen="M005-03-2" class="whitespace-nowrap" />
                          <span class="ml-2">※備考への表示状況は売買契約書レイアウト画面にて確認してください</span
                          >
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <vs-textarea @blur="focusOut()" @focus="onFocus(`kainushi.kainushi_urinushi_soho_kakuninjiko_biko.${index}`)" v-model="kainushi.kainushi_urinushi_soho_kakuninjiko_biko" maxlength="3000" rows="5"></vs-textarea>
                        <span class="tooltip-custom -mt-4" :class="addPadding(`kainushi.kainushi_urinushi_soho_kakuninjiko_biko.${index}`)">{{showMaxlength(3000, kainushi.kainushi_urinushi_soho_kakuninjiko_biko, `kainushi.kainushi_urinushi_soho_kakuninjiko_biko.${index}`)}}</span>
                      </td>
                    </tr>
                  </table>
            </draggable>
            <table class="w-full">
              <tr>
                <td>
                  <div class="flex justify-end py-1">
                    <vs-button class="primary mr-4 btn-positive" @click="addNote(1)">項目追加</vs-button>
                    <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="handleDeleteItem('kainushi')">項目削除</vs-button>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <!-- bsc-03 "-->
        <div v-if="bscPattern === 'bsc-03'" :id="`${arrayCommentId[1]}`">
          <table>
            <tr>
              <td colspan="12" class="part-parent-name">
                <span style="padding-left: 7px">
                  契約不適合責任（瑕疵担保責任）の履行に関する措置
                </span>
              </td>
            </tr>

            <tr>
              <td class="w-1/2" style="position: relative;">
                <vs-checkbox @input="lostFocus" class="ml-4"
                            v-model="keiyakufutekigo_rikosochi1"
                            vs-name="keiyakufutekigo_rikosochi1">1．住宅販売瑕疵担保補償金の供託</vs-checkbox>
                <div class="text-warning ml-4" v-if="formValidation.keiyakufutekigo_rikosochi1.isWarning">{{formValidation.keiyakufutekigo_rikosochi1.warningMsg}}</div>

              </td>
              <td>
                <vs-checkbox @input="lostFocus"
                  class="ml-4"
                  v-model="keiyakufutekigo_rikosochi2"
                  vs-name="keiyakufutekigo_rikosochi2"
                  >2．住宅瑕疵担保責任保険の付保</vs-checkbox>
                  <div class="text-warning ml-4" v-if="formValidation.keiyakufutekigo_rikosochi2.isWarning">{{formValidation.keiyakufutekigo_rikosochi2.warningMsg}}</div>
              </td>
            </tr>
          </table>

          <div>
            <table class="w-full">
              <tr>
                <td rowspan="4" class="w-1/4">
                  <div class="flex">
                    <span class="text-center">「以下余白」の表示</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="flex items-center">
                    <vs-checkbox v-model="keiyakufutekigo_rikosochi_biko_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">末尾に「以下余白」を表示する</span>
                  </div>
                </td>
              </tr>
            </table>
            <table class="w-full">
              <tr>
                <td rowspan="4" class="w-1/4">
                  <div class="flex">
                    <span class="text-center">黒点／ナンバリング表示</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="flex items-center">
                    <vs-checkbox v-model="keiyakufutekigo_rikosochi_biko_numbering" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">黒点／ナンバリングを表示する</span>
                  </div>
                </td>
              </tr>
            </table>
            <draggable v-model="keiyakufutekigo_rikosochi_bikoInputs" handle=".handle">
              <table class="w-full" v-for="(keiyakufutekigo, index) in keiyakufutekigo_rikosochi_bikoInputs" :key="`note-${index}`">
                <tr>
                  <td rowspan="4" class="w-1/4">
                    <div class="flex">
                      <vs-checkbox @input="lostFocus" v-model="keiyakufutekigo.checkboxDelete" class="inline-flex"></vs-checkbox>
                      <span class="p-3">備考 {{ index + 1 }} </span>
                      <div class="handle pt-3 pl-3 cursor-default w-27">
                        <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                          <DragBlackIcon />
                        </vx-tooltip>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="flex items-center">
                      <!-- bsc-03 -->
                      <BunshoTemplate v-model="keiyakufutekigo.keiyakufutekigo_rikosochi_biko" screen="M005-03-3" class="whitespace-nowrap"/>
                      <span class="ml-2">※備考への表示状況は売買契約書レイアウト画面にて確認してください</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <vs-textarea
                      v-model="keiyakufutekigo.keiyakufutekigo_rikosochi_biko" maxlength="3000"
                      rows="5"
                      @blur="focusOut()" @focus="onFocus(`keiyakufutekigo.keiyakufutekigo_rikosochi_biko.${index}`)"
                    ></vs-textarea>
                    <span class="tooltip-custom -mt-4" :class="addPadding(`keiyakufutekigo.keiyakufutekigo_rikosochi_biko.${index}`)">{{showMaxlength(3000, keiyakufutekigo.keiyakufutekigo_rikosochi_biko, `keiyakufutekigo.keiyakufutekigo_rikosochi_biko.${index}`)}}</span>
                  </td>
                </tr>
              </table>
            </draggable>
            <table class="w-full">
              <tr>
                <td>
                  <div class="flex justify-end py-1">
                    <vs-button class="primary mr-4 btn-positive" @click="addNote(2)">項目追加</vs-button>
                    <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="handleDeleteItem('keiyakufutekigo')">項目削除</vs-button>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!-- common -->
        <div>
          <table :id="`${arrayCommentId[2]}`">
            <tr>
              <td colspan="2" class="part-parent-name">
                  <span style="padding-left: 7px">特約</span>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div class="flex">
                  <span class="ml-4 mt-3">公租公課の清算基準日</span>
                  <radio-box @input="lostFocus"
                    class="ml-14 pb-2"
                    style="padding-left: 200px"
                    v-model="seisankijunbi"
                    vs-name="seisankijunbi"
                    vs-value="0"
                    :class=" formValidation.seisankijunbi.isError ? 'is-error' : '' ">1月1日</radio-box>
                </div>
                <div class="flex">
                  <radio-box @input="lostFocus" style="padding-left: 355px"
                    class="ml-14 pb-2"
                    v-model="seisankijunbi"
                    vs-name="seisankijunbi"
                    vs-value="1"
                    :class=" formValidation.seisankijunbi.isError ? 'is-error' : '' ">4月1日</radio-box>
                </div>
                <div style="padding-left:358px; color:red" v-if="formValidation.seisankijunbi.isError">{{formValidation.seisankijunbi.errorMsg}}</div>
              </td>
            </tr>
            <tr>
              <div>
                <table class="w-full">
                  <tr>
                    <td rowspan="4" class="w-1/4">
                      <div class="flex">
                        <span class="text-center">「以下余白」の表示</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="flex items-center">
                        <vs-checkbox v-model="tokuyaku_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                        <span class="ml-2">末尾に「以下余白」を表示する</span>
                      </div>
                    </td>
                  </tr>
                </table>
                <table class="w-full">
                  <tr>
                    <td rowspan="4" class="w-1/4">
                      <div class="flex">
                        <span class="text-center">黒点／ナンバリング表示</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="flex items-center">
                        <vs-checkbox v-model="tokuyaku_numbering" class="inline-flex"></vs-checkbox>
                        <span class="ml-2">黒点／ナンバリングを表示する</span>
                      </div>
                    </td>
                  </tr>
                </table>
                <draggable v-model="tokuyakuInputs" handle=".handle">
                  <table class="w-full" v-for="(tokuyaku, index) in tokuyakuInputs" :key="`note-${index}`">
                    <tr>
                      <td rowspan="4" class="w-1/4">
                        <div class="flex">
                          <vs-checkbox @input="lostFocus" v-model="tokuyaku.checkboxDelete" class="inline-flex" ></vs-checkbox>
                          <span class="p-3">{{ index + 1 }}. </span>
                          <div class="handle pt-3 pl-3 cursor-default w-27">
                            <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                              <DragBlackIcon />
                            </vx-tooltip>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="flex items-center justify-start">
                          <vs-checkbox @input="lostFocus" v-model="tokuyaku.ikabesshi" class="inline-flex mr-4">以下＜別紙＞</vs-checkbox>
                          <BunshoTemplate v-model="tokuyaku.tokuyaku" screen="M005-03-1" class="whitespace-nowrap" />
                          <span class="ml-2 w-57">※備考への表示状況は売買契約書レイアウト画面にて確認してください</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <vs-textarea @blur="focusOut()" @focus="onFocus(`tokuyaku.tokuyaku.${index}`)" v-model="tokuyaku.tokuyaku" rows="5" maxlength="3000"></vs-textarea>
                        <span class="tooltip-custom -mt-4" :class="addPadding(`tokuyaku.tokuyaku.${index}`)">{{showMaxlength(3000, tokuyaku.tokuyaku, `tokuyaku.tokuyaku.${index}`)}}</span>
                      </td>
                    </tr>
                  </table>
                </draggable>
                <table class="w-full">
                  <tr>
                    <td>
                      <div class="flex justify-end py-1">
                        <vs-button class="primary mr-4 btn-positive" @click="addNote(3)">項目追加</vs-button>
                        <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="handleDeleteItem('tokuyaku')">項目削除</vs-button>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </tr>
          </table>
          <table :id="`${arrayCommentId[3]}`">
            <tr>
              <td colspan="2">
                <div class="flex mb-2 items-center">
                  <span class="self-center ml-10 mr-5" style="width:8.8%">文字サイズ・位置</span>
                  <vs-checkbox class="w-1/3 mr-0" @input="lostFocus" v-model="urinushi_chuoyose">文字位置を中央寄せにする </vs-checkbox>
                  <span class="self-center ml-6 mr-5" style="width:11.6%">文字サイズ・位置</span>
                  <vs-checkbox class="w-1/3" @input="lostFocus" v-model="kainushi_chuoyose">文字位置を中央寄せにする </vs-checkbox>
                </div>
                <div class="flex">
                  <span class="self-center ml-10 mr-5" style="width:10%">売主</span>
                  <div class="w-1/3 mr-1">
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('urinushi')" v-model="urinushi" maxlength="48" name="urinushi"></vs-input>
                    <span class="tooltip-custom" :class="addPadding('urinushi')">{{showMaxlength(48, urinushi, 'urinushi')}}</span>
                    <div class="text-warning" v-if="formValidation.urinushi.isWarning">{{formValidation.urinushi.warningMsg}}</div>
                  </div>
                  <span class="self-center ml-20 mr-5" style="width:13%">と買主</span>
                  <div class="w-1/3">
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('kainushi')" v-model="kainushi" maxlength="48" name="kainushi"></vs-input>
                    <span class="tooltip-custom" :class="addPadding('kainushi')">{{showMaxlength(48, kainushi, 'kainushi')}}</span>
                    <div class="text-warning" v-if="formValidation.kainushi.isWarning">{{formValidation.kainushi.warningMsg}}</div>
                  </div>
                  <span class="self-center ml-10" style="width:8%">とは</span>
                </div>
                <div class="pt-5">
                  <p class="ml-8">
                    表記不動産の売買契約（以下「本契約」という。）を締結した。その証として本契約書２通を作成し、売主・買主署（記）名押印のうえ各その1通を保有する。
                  </p>
                </div>
                <div class="flex mt-5 ml-5" :id="`${arrayCommentId[4]}`">
                  <DatePickerCustom
                    @lost-focus="lostFocus();"
                    class="ml-2"
                    name = "honkeiyaku_tekisetsu_nengappi"
                    v-model="honkeiyaku_tekisetsu_nengappi"
                    format="yyyy-MM-dd"
                    separate="-"
                    :date="honkeiyaku_tekisetsu_nengappi"
                    :checkboxvalue="honkeiyaku_tekisetsu_nengappi_checkbox"
                    v-on:change-checkbox="honkeiyaku_tekisetsu_nengappi_checkbox = $event"
                    :class="formValidation.honkeiyaku_tekisetsu_nengappi.isWarning ? 'is-warning' : ''"
                  />
                </div>
                <div class="text-warning" style="padding-left:25px" v-if="formValidation.honkeiyaku_tekisetsu_nengappi.isWarning">{{formValidation.honkeiyaku_tekisetsu_nengappi.warningMsg}}</div>
                <div style="padding-left:25px;color: red" v-if="formValidation.honkeiyaku_tekisetsu_nengappi.isError">{{formValidation.honkeiyaku_tekisetsu_nengappi.errorMsg}}</div>
              </td>
            </tr>

            <tr v-show="this.urinushishomeiInputTotal.length > 0 || this.kainushishomeiInputTotal.length > 0 ">
              <td colspan="2" class="flex justify-between">
                <span class="ml-5 self-center">※売主 1と買主１以外は別紙に記載されます。</span>
                <div>
                  <div>
                    <span>売主・買主名を売買契約書に反映しない場合はチェック</span>
                  </div>
                  <div style="text-align: right">
                    <vs-button @click="CheckboxAll(true)">全チェック</vs-button>
                    <vs-button color="positive" type="filled" text-color="#7367F0" class="ml-4 btn-positive" @click="CheckboxAll(false)">全チェック解除</vs-button>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <table class="w-full" >
                <tr class="flex">
                  <td class="w-1/4">
                    <span class="self-center ml-10 mr-5">文字サイズ・位置</span>
                  </td>
                  <td class="w-3/4">
                    <vs-checkbox @input="lostFocus" v-model="urinushishomei_chuoyose">文字位置を中央寄せにする </vs-checkbox>
                  </td>
                </tr>
              </table>
              <table>
                <tr>
                  <td rowspan="2" class="w-1/4">
                    <div class="flex">
                      <vs-checkbox @input="lostFocus" v-model="firstUrinushishomeiInputs.checkboxDelete" class="inline-flex" ></vs-checkbox>
                      <span class="p-3">売主 1 </span>
                    </div>
                  </td>
                  <td>
                    <div class="flex">
                      <span class="self-center mr-10 ml-5">住所</span>
                      <div class="w-2/3">
                        <vs-textarea @blur="focusOut()" @focus="onFocus(`firstUrinushishomeiInputs.jusho`)" maxlength="94" v-model="firstUrinushishomeiInputs.jusho" />
                        <span class="tooltip-custom -mt-4" :class="addPadding(`firstUrinushishomeiInputs.jusho`)">{{showMaxlength(94, firstUrinushishomeiInputs.jusho, `firstUrinushishomeiInputs.jusho`)}}</span>
                      </div>
                    </div>
                    <div class="flex mt-5">
                      <span class="self-center mr-10 ml-5">氏名</span>
                      <div class="w-1/3 mr-2">
                        <vs-textarea @blur="focusOut()" @focus="onFocus(`firstUrinushishomeiInputs.shimei`)" maxlength="94" v-model="firstUrinushishomeiInputs.shimei" />
                        <span class="tooltip-custom -mt-4" :class="addPadding(`firstUrinushishomeiInputs.shimei`)">{{showMaxlength(94, firstUrinushishomeiInputs.shimei, `firstUrinushishomeiInputs.shimei`)}}</span>
                      </div>
                      <vs-checkbox @input="lostFocus" v-model="firstUrinushishomeiInputs.baikei_insatsushinai" />
                      <span class="self-center" >売買契約書に印刷しない</span>
                    </div>
                  </td>
                </tr>
              </table>
              <draggable v-model="urinushishomeiInputs" handle=".handle">
                <table class="w-full" v-for="(urinushishomei, index) in urinushishomeiInputs" :key="`note-${index}`">
                  <tr>
                    <td rowspan="2" class="w-1/4">
                      <div class="flex">
                        <vs-checkbox @input="lostFocus" v-model="urinushishomei.checkboxDelete" class="inline-flex" ></vs-checkbox>
                        <v-select
                          :options="selectOptions57"
                          :clearable="false"
                          v-model="urinushishomei.urinushi_type"
                          name="urinushi_type"
                          :reduce="option => option.value"
                          @input="setselectUrinushishomei(index)"
                          class="mr-4 w-1/2"
                          :class="[!isShowComment && !isOpenPreview ? 'max-w-120' : 'min-w-200']"
                        >
                          <span slot="no-options">該当する選択肢がありません。</span>
                        </v-select>
                        <span class="p-3" v-if="urinushishomei.urinushi_type === '売主' && urinushishomeiInputsIndex">{{ urinushishomeiInputsIndex[index] }}</span>
                        <div class="handle pt-3 pl-3 cursor-default w-27">
                          <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                            <DragBlackIcon />
                          </vx-tooltip>
                        </div>
                      </div>
                      <div class="w-2/3 ml-10" :class="[!isShowComment && !isOpenPreview ? 'max-w-120' : '']">
                        <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`urinushishomei.sonohoka_type.${index}`)" maxlength="10"  v-model="urinushishomei.sonohoka_type" :disabled="urinushishomei.urinushi_type !== 'その他フリーワード'"/>
                        <span class="tooltip-custom" :class="addPadding(`urinushishomei.sonohoka_type.${index}`)">{{showMaxlength(10, urinushishomei.sonohoka_type, `urinushishomei.sonohoka_type.${index}`)}}</span>
                      </div>
                    </td>
                    <td>
                      <div class="flex">
                        <span class="self-center mr-10 ml-5">住所</span>
                        <div class="w-2/3">
                          <vs-textarea @blur="focusOut()" @focus="onFocus(`urinushishomei.jusho.${index}`)" maxlength="94" v-model="urinushishomei.jusho" />
                          <span class="tooltip-custom -mt-4" :class="addPadding(`urinushishomei.jusho.${index}`)">{{showMaxlength(94, urinushishomei.jusho, `urinushishomei.jusho.${index}`)}}</span>
                        </div>
                      </div>
                      <div class="flex mt-5">
                        <span class="self-center mr-10 ml-5">氏名</span>
                        <div class="w-1/3 mr-2">
                          <vs-textarea @blur="focusOut()" @focus="onFocus(`urinushishomei.shimei.${index}`)" maxlength="94" v-model="urinushishomei.shimei" />
                          <span class="tooltip-custom -mt-4" :class="addPadding(`urinushishomei.shimei.${index}`)">{{showMaxlength(94, urinushishomei.shimei, `urinushishomei.shimei.${index}`)}}</span>
                        </div>
                        <vs-checkbox @input="lostFocus" v-model="urinushishomei.baikei_insatsushinai" />
                        <span class="self-center" >売買契約書に印刷しない</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </draggable>
              <table class="w-full">
                <tr class="table-border-left-right">
                  <div class="flex justify-end py-1 px-2">
                    <vs-button class="primary mr-4 btn-positive" :disabled="urinushishomeiInputs.length >= 19" @click="addNote(4)"
                      >売主追加
                    </vs-button>
                    <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="handleDeleteItem('urinushishomei')">売主削除</vs-button>
                  </div>
                </tr>
              </table>
            </tr>
            <tr>
              <table>
                <tr class="flex">
                  <td class="w-1/4">
                    <span class="self-center ml-10 mr-5">文字サイズ・位置</span>
                  </td>
                  <td class="w-3/4">
                    <vs-checkbox @input="lostFocus" v-model="kainushishomei_chuoyose">文字位置を中央寄せにする </vs-checkbox>
                  </td>
                </tr>
              </table>
              <table class="w-full">
                <tr>
                  <td class="w-1/4">
                    <div class="flex">
                      <vs-checkbox @input="lostFocus" v-model="firstKainushishomeiInputs.checkboxDelete" class="inline-flex" ></vs-checkbox>
                      <span class="p-3">買主 1 </span>
                    </div>
                  </td>
                  <td>
                    <div class="flex">
                      <span class="self-center mr-10 ml-5">住所</span>
                      <div class="w-2/3">
                        <vs-textarea @blur="focusOut()" @focus="onFocus(`firstKainushishomeiInputs.jusho`)" maxlength="94" v-model="firstKainushishomeiInputs.jusho" />
                        <span class="tooltip-custom -mt-4" :class="addPadding(`firstKainushishomeiInputs.jusho`)">{{showMaxlength(94, firstKainushishomeiInputs.jusho, `firstKainushishomeiInputs.jusho`)}}</span>
                      </div>
                    </div>
                    <div class="flex mt-5">
                      <span class="self-center mr-10 ml-5">氏名</span>
                      <div class="w-1/3 mr-2">
                        <vs-textarea @blur="focusOut()" @focus="onFocus(`firstKainushishomeiInputs.shimei`)" maxlength="94" v-model="firstKainushishomeiInputs.shimei" />
                        <span class="tooltip-custom -mt-4" :class="addPadding(`firstKainushishomeiInputs.shimei`)">{{showMaxlength(94, firstKainushishomeiInputs.shimei, `firstKainushishomeiInputs.shimei`)}}</span>
                      </div>
                      <vs-checkbox @input="lostFocus" v-model="firstKainushishomeiInputs.baikei_insatsushinai" />
                      <span class="self-center" >売買契約書に印刷しない</span>
                    </div>
                  </td>
                </tr>
              </table>
              <draggable v-model="kainushishomeiInputs" handle=".handle">
                <table class="w-full" v-for="(kainushishomei, index) in kainushishomeiInputs" :key="`note-${index}`">
                  <tr>
                    <td class="w-1/4">
                      <div class="flex">
                        <vs-checkbox @input="lostFocus" v-model="kainushishomei.checkboxDelete" class="inline-flex" ></vs-checkbox>
                        <v-select
                          :options="selectOptions58"
                          :clearable="false"
                          v-model="kainushishomei.kainushi_type"
                          name="kainushi_type"
                          :reduce="option => option.value"
                          @input="setselectKainushishomei(index)"
                          class="mr-4 w-1/2"
                          :class="[!isShowComment && !isOpenPreview ? 'max-w-120' : 'min-w-200']"
                        >
                          <span slot="no-options">該当する選択肢がありません。</span>
                        </v-select>
                        <span class="p-3" v-if="kainushishomei.kainushi_type === '買主' && kainushishomeiInputsIndex">{{ kainushishomeiInputsIndex[index] }}</span>
                        <div class="handle pt-3 pl-3 cursor-default w-27">
                          <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                            <DragBlackIcon />
                          </vx-tooltip>
                        </div>
                      </div>
                      <div class="w-2/3 ml-10" :class="[!isShowComment && !isOpenPreview ? 'max-w-120' : '']">
                        <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`kainushishomei.sonohoka_type.${index}`)" maxlength="10"  v-model="kainushishomei.sonohoka_type" :disabled="kainushishomei.kainushi_type !== 'その他フリーワード' "/>
                        <span class="tooltip-custom" :class="addPadding(`kainushishomei.sonohoka_type.${index}`)">{{showMaxlength(10, kainushishomei.sonohoka_type, `kainushishomei.sonohoka_type.${index}`)}}</span>
                      </div>
                    </td>
                    <td>
                      <div class="flex">
                        <span class="self-center mr-10 ml-5">住所</span>
                        <div class="w-2/3">
                          <vs-textarea @blur="focusOut()" @focus="onFocus(`kainushishomei.jusho.${index}`)" maxlength="94" v-model="kainushishomei.jusho" />
                          <span class="tooltip-custom -mt-4" :class="addPadding(`kainushishomei.jusho.${index}`)">{{showMaxlength(94, kainushishomei.jusho, `kainushishomei.jusho.${index}`)}}</span>
                        </div>
                      </div>
                      <div class="flex mt-5">
                        <span class="self-center mr-10 ml-5">氏名</span>
                        <div class="w-1/3 mr-2">
                          <vs-textarea @blur="focusOut()" @focus="onFocus(`kainushishomei.shimei.${index}`)" maxlength="94" v-model="kainushishomei.shimei" />
                          <span class="tooltip-custom -mt-4" :class="addPadding(`kainushishomei.shimei.${index}`)">{{showMaxlength(94, kainushishomei.shimei, `kainushishomei.shimei.${index}`)}}</span>
                        </div>
                        <vs-checkbox @input="lostFocus" v-model="kainushishomei.baikei_insatsushinai" />
                        <span class="self-center" >売買契約書に印刷しない</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </draggable>
              <table class="w-full">
                <tr>
                  <td>
                    <div class="flex justify-end py-1">
                      <vs-button class="primary mr-4 btn-positive" :disabled="kainushishomeiInputs.length >= 19" @click="addNote(5)">買主追加</vs-button>
                      <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="handleDeleteItem('kainushishomei')">買主削除</vs-button>
                    </div>
                  </td>
                </tr>
              </table>
            </tr>
          </table>
        </div>
        <!-- common -->
        <div>
          <div :id="`${arrayCommentId[5]}`">
            <table>
              <tr>
                <td class="part-parent-name" colspan="12">
                  <span style="padding-left: 7px">自社情報</span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="flex mt-5 justify-between">
                    <span class="self-center ml-4">免許証番号</span>
                    <div class="w-2/3 mr-6">
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('jisha_menkyoshobango')" v-model="jisha_menkyoshobango" name="jisha_menkyoshobango" maxlength="27"/>
                      <span class="tooltip-custom" :class="addPadding('jisha_menkyoshobango')">{{showMaxlength(27, jisha_menkyoshobango, 'jisha_menkyoshobango')}}</span>
                    </div>
                  </div>
                  <div class="flex mt-5 justify-between">
                    <span class="mt-3 ml-4">商号</span>
                    <div class="w-2/3 mr-6">
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('jisha_shogo')" maxlength="27"  v-model="jisha_shogo" name="jisha_shogo" />
                      <span class="tooltip-custom" :class="addPadding('jisha_shogo')">{{showMaxlength(27, jisha_shogo, 'jisha_shogo')}}</span>
                      <div class="text-warning" v-if="formValidation.jisha_shogo.isWarning">{{formValidation.jisha_shogo.warningMsg}}</div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td style="width: 120px">
                  <div class="grid">
                    <span class="self-center ml-4"> 本社情報</span>
                  </div>
                </td>
                <td class="p-0">
                  <table class="border-none">
                    <tr>
                      <td class="border-top-none border-bottom-none border-left-none"></td>
                      <td class="border-none">
                        <div class="w-11/12 ml-6 flex justify-end">
                          <span>契約書に本社情報を表示する</span>
                          <vs-checkbox class="mr-0" v-model="wakaregyoshajoho_keiyasho_hoshajoho_hyojishinai"></vs-checkbox>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="border-top-none border-bottom-none border-left-none align-top pt-5 w-1595px">
                        <span>主たる事務所の所在地</span>
                      </td>
                      <td  class="border-none">
                        <div class="w-11/12 mr-18 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('jisha_shutaru_jimusho_shozaichi')" maxlength="54"  v-model="jisha_shutaru_jimusho_shozaichi" name="jisha_shutaru_jimusho_shozaichi" :disabled="wakaregyoshajoho_keiyasho_hoshajoho_hyojishinai === false"/>
                          <span class="tooltip-custom" :class="addPadding('jisha_shutaru_jimusho_shozaichi')">{{showMaxlength(54, jisha_shutaru_jimusho_shozaichi, 'jisha_shutaru_jimusho_shozaichi')}}</span>
                          <div class="text-warning" v-if="formValidation.jisha_shutaru_jimusho_shozaichi.isWarning">{{formValidation.jisha_shutaru_jimusho_shozaichi.warningMsg}}</div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="border-top-none border-bottom-none border-left-none align-top pt-5 w-1595px">
                        <span>代表者役職</span>
                      </td>
                      <td  class="border-none">
                        <div class="w-11/12 mr-18 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('jisha_daihyoshayakusho')" maxlength="27"  v-model="jisha_daihyoshayakusho" name="jisha_daihyoshayakusho" :disabled="wakaregyoshajoho_keiyasho_hoshajoho_hyojishinai === false"/>
                          <span class="tooltip-custom" :class="addPadding('jisha_daihyoshayakusho')">{{showMaxlength(27, jisha_daihyoshayakusho, 'jisha_daihyoshayakusho')}}</span>
                          <div class="text-warning" v-if="formValidation.jisha_daihyoshayakusho.isWarning">{{formValidation.jisha_daihyoshayakusho.warningMsg}}</div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="border-top-none border-bottom-none border-left-none align-top pt-5 w-1595px">
                        <span>代表者氏名</span>
                      </td>
                      <td  class="border-none">
                        <div class="w-11/12 mr-18 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('jisha_daihyoshashimei')" maxlength="27"  v-model="jisha_daihyoshashimei" name="jisha_daihyoshashimei" :disabled="wakaregyoshajoho_keiyasho_hoshajoho_hyojishinai === false"/>
                          <span class="tooltip-custom" :class="addPadding('jisha_daihyoshashimei')">{{showMaxlength(27, jisha_daihyoshashimei, 'jisha_daihyoshashimei')}}</span>
                          <div class="text-warning" v-if="formValidation.jisha_daihyoshashimei.isWarning">{{formValidation.jisha_daihyoshashimei.warningMsg}}</div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td style="width: 120px">
                  <div class="grid">
                    <span class="self-center ml-4"> 事業所情報</span>
                  </div>
                </td>
                <td class="p-0">
                  <table class="border-none">
                    <tr>
                      <td class="border-top-none border-bottom-none border-left-none align-top pt-5 w-1595px">
                        <span>住所</span>
                      </td>
                      <td  class="border-none">
                        <div class="w-11/12 mr-18 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('jisha_tenpojoho_jusho')" maxlength="54"  v-model="jisha_tenpojoho_jusho" name="jisha_tenpojoho_jusho" />
                          <span class="tooltip-custom" :class="addPadding('jisha_tenpojoho_jusho')">{{showMaxlength(54, jisha_tenpojoho_jusho, 'jisha_tenpojoho_jusho')}}</span>
                          <div class="text-warning" v-if="formValidation.jisha_tenpojoho_jusho.isWarning">{{formValidation.jisha_tenpojoho_jusho.warningMsg}}</div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="border-top-none border-bottom-none border-left-none align-top pt-5 w-1595px">
                        <span>事業所名・部門名</span>
                      </td>
                      <td  class="border-none">
                        <div class="w-11/12 mr-18 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('jisha_tenpojoho_jimushomei')" maxlength="27"  v-model="jisha_tenpojoho_jimushomei" name="jisha_tenpojoho_jimushomei" />
                          <span class="tooltip-custom" :class="addPadding('jisha_tenpojoho_jimushomei')">{{showMaxlength(27, jisha_tenpojoho_jimushomei, 'jisha_tenpojoho_jimushomei')}}</span>
                          <div class="text-warning" v-if="formValidation.jisha_tenpojoho_jimushomei.isWarning">{{formValidation.jisha_tenpojoho_jimushomei.warningMsg}}</div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="border-top-none border-bottom-none border-left-none align-top pt-5 w-1595px">
                        <span>役職</span>
                      </td>
                      <td  class="border-none">
                        <div class="w-11/12 mr-18 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('jisha_tenpojoho_yakushoku')" maxlength="27"  v-model="jisha_tenpojoho_yakushoku" name="jisha_tenpojoho_yakushoku" />
                          <span class="tooltip-custom" :class="addPadding('jisha_tenpojoho_yakushoku')">{{showMaxlength(27, jisha_tenpojoho_yakushoku, 'jisha_tenpojoho_yakushoku')}}</span>
                          <div class="text-warning" v-if="formValidation.jisha_tenpojoho_yakushoku.isWarning">{{formValidation.jisha_tenpojoho_yakushoku.warningMsg}}</div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="border-top-none border-bottom-none border-left-none align-top pt-5 w-1595px">
                        <span>事業所長名・部門長名</span>
                      </td>
                      <td  class="border-none">
                        <div class="w-11/12 mr-18 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('jisha_tenpojoho_jimushochona')" maxlength="27"  v-model="jisha_tenpojoho_jimushochona" name="jisha_tenpojoho_jimushochona" />
                          <span class="tooltip-custom" :class="addPadding('jisha_tenpojoho_jimushochona')">{{showMaxlength(27, jisha_tenpojoho_jimushochona, 'jisha_tenpojoho_jimushochona')}}</span>
                          <div class="text-warning" v-if="formValidation.jisha_tenpojoho_jimushochona.isWarning">{{formValidation.jisha_tenpojoho_jimushochona.warningMsg}}</div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td colspan="2">
                  <span class="ml-6"> 宅地建物取引士 </span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="flex justify-between">
                    <span class="mt-3 mr-16 ml-8">登録番号</span>
                    <div class="w-2/3 mr-6">
                      <vs-input
                      @blur="lostFocus, focusOut()" @focus="onFocus('torihikishi2_torokubango')"
                      v-model="torihikishi2_torokubango"
                      name="torihikishi2_torokubango"
                      maxlength="27"
                      />
                      <span class="tooltip-custom" :class="addPadding('torihikishi2_torokubango')">{{showMaxlength(27, torihikishi2_torokubango, 'torihikishi2_torokubango')}}</span>
                      <div class="text-warning" v-if="formValidation.torihikishi2_torokubango.isWarning">{{formValidation.torihikishi2_torokubango.warningMsg}}</div>
                    </div>
                  </div>
                  <div class="flex mt-5 justify-between">
                    <span class=" mt-3 mr-16 ml-8">氏名</span>
                    <div class="w-2/3 mr-6 ">
                      <vs-input
                        maxlength="23"
                        @blur="lostFocus, focusOut()" @focus="onFocus('torihikishi2_shimei')"
                        v-model="torihikishi2_shimei"
                        name="torihikishi2_shimei"
                        :class="{'input-warning' : formValidation.torihikishi2_shimei.isWarning}" />
                        <span class="tooltip-custom" :class="addPadding('torihikishi2_shimei')">{{showMaxlength(23, torihikishi2_shimei, 'torihikishi2_shimei')}}</span>
                      <div class="text-warning" v-if="formValidation.torihikishi2_shimei.isWarning">{{formValidation.torihikishi2_shimei.warningMsg}}</div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          
          <table class="w-full">
            <tr>
              <td colspan="12"  class="part-parent-name">
                <span style="padding-left: 7px">他宅建業者情報</span>
              </td>
            </tr>
          </table>
          <table class="w-full" :id="`${arrayCommentId[6]}`" >
            <tr>
              <table class="w-full" v-for="(tatakkengyoshajoho, index) in tatakkengyoshajohoInputs" :key="`note-${index}`">
                <tr>
                  <td colspan="4" class="part-parent-name">
                    <div class="flex justify-between">
                      <div class="flex w-1/2">
                        <span class="mr-16 self-center">他宅建業者情報 {{ index + 1 }}</span>
                        <!-- <v-select
                          :options="selectOptions301"
                          :clearable="false"
                          v-model="tatakkengyoshajohoInputs[index].torihikitaiyo"
                          name="torihikitaiyo"
                          :reduce="option => option.value"
                          @input="lostFocus();"
                          class="mr-4 max-w-120 w-48 v-select-bsc" 
                        >
                          <span slot="no-options">該当する選択肢がありません。</span>
                        </v-select> -->
                      </div>
                      <div class="flex">
                        <span class="self-center">契約書立会い印欄に表示しない</span>
                        <vs-checkbox v-model="tatakkengyoshajoho.keiyakusho_tachiai_iran_hyojishinai" :disabled="torihiki_taiyo_tatakkengyosha_shasenhiki === true"></vs-checkbox>
                        <vs-button @click="popupActiveClearAllTatakkengyoshajoho = true; clearData=index" >他宅建業者情報をクリア</vs-button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td rowspan="13" style="width: 70px">
                    <div class="flex">
                      <vs-checkbox @input="lostFocus" v-model="tatakkengyoshajoho.checkboxDelete" class="inline-flex" :disabled="torihiki_taiyo_tatakkengyosha_shasenhiki === true"></vs-checkbox>
                      <span> {{ index + 1 }} </span>
                    </div>
                  </td>
                  <td colspan="2" class="border-bottom-none border-right-none">
                    <span class="self-center ml-2">免許証番号</span>
                  </td>
                  <td class="border-bottom-none border-left-none">
                    <vs-input
                      @blur="focusOut()" @focus="onFocus(`tatakkengyoshajoho.menkyoshobango.${index}`)"
                      class="w-11/12"
                      v-model="tatakkengyoshajoho.menkyoshobango"
                      maxlength="38"
                      :disabled="torihiki_taiyo_tatakkengyosha_shasenhiki === true"
                    />
                    <span class="tooltip-custom" :class="addPadding(`tatakkengyoshajoho.menkyoshobango.${index}`)">{{showMaxlength(38, tatakkengyoshajoho.menkyoshobango, `tatakkengyoshajoho.menkyoshobango.${index}`)}}</span>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="border-top-none border-right-none">
                    <span class="self-center mr-24 ml-2">商号</span>
                  </td>
                  <td class="border-top-none border-left-none">
                    <vs-input @blur="focusOut()" @focus="onFocus(`tatakkengyoshajoho.shogo.${index}`)" class="w-11/12" maxlength="38" v-model="tatakkengyoshajoho.shogo" :disabled="torihiki_taiyo_tatakkengyosha_shasenhiki === true"/>
                    <span class="tooltip-custom" :class="addPadding(`tatakkengyoshajoho.shogo.${index}`)">{{showMaxlength(38, tatakkengyoshajoho.shogo, `tatakkengyoshajoho.shogo.${index}`)}}</span>
                  </td>
                </tr>
                <tr>
                  <td style="width: 15%" rowspan="4">
                    <span class="self-center">本社情報</span>
                  </td>
                  <td style="width: 15%" class="border-bottom-none border-right-none">
                  </td>
                  <td class="border-bottom-none border-left-none">
                    <div class="w-11/12 flex justify-end">
                      <span>契約書に本社情報を表示する</span>
                      <vs-checkbox class="mr-0" v-model="tatakkengyoshajoho.tatakkengyoshajoho_keiyasho_hoshajoho_hyojishinai" :disabled="torihiki_taiyo_tatakkengyosha_shasenhiki === true"></vs-checkbox>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="border-top-none border-right-none border-bottom-none">
                    <span>主たる事務所の所在地</span>
                  </td>
                  <td class="border-top-none border-left-none border-bottom-none">
                    <vs-input @blur="focusOut()" @focus="onFocus(`tatakkengyoshajoho.shutaru_jimusho_shozaichi.${index}`)" class="w-11/12" maxlength="76" v-model="tatakkengyoshajoho.shutaru_jimusho_shozaichi" :disabled="tatakkengyoshajoho.tatakkengyoshajoho_keiyasho_hoshajoho_hyojishinai === false || torihiki_taiyo_tatakkengyosha_shasenhiki === true"/>
                    <span class="tooltip-custom" :class="addPadding(`tatakkengyoshajoho.shutaru_jimusho_shozaichi.${index}`)">{{showMaxlength(76, tatakkengyoshajoho.shutaru_jimusho_shozaichi, `tatakkengyoshajoho.shutaru_jimusho_shozaichi.${index}`)}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="border-top-none border-right-none border-bottom-none">
                    <span>代表者役職</span>
                  </td>
                  <td class="border-top-none border-left-none border-bottom-none">
                    <vs-input @blur="focusOut()" @focus="onFocus(`tatakkengyoshajoho.daihyoshayakusho.${index}`)" class="w-11/12" maxlength="17" v-model="tatakkengyoshajoho.daihyoshayakusho" :disabled="tatakkengyoshajoho.tatakkengyoshajoho_keiyasho_hoshajoho_hyojishinai === false || torihiki_taiyo_tatakkengyosha_shasenhiki === true"/>
                    <span class="tooltip-custom" :class="addPadding(`tatakkengyoshajoho.daihyoshayakusho.${index}`)">{{showMaxlength(17, tatakkengyoshajoho.daihyoshayakusho, `tatakkengyoshajoho.daihyoshayakusho.${index}`)}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="border-top-none border-right-none border-bottom-none">
                    <span>代表者氏名</span>
                  </td>
                  <td class="border-top-none border-left-none border-bottom-none">
                    <vs-input @blur="focusOut()" @focus="onFocus(`tatakkengyoshajoho.daihyoshashimei.${index}`)" class="w-11/12" maxlength="20" v-model="tatakkengyoshajoho.daihyoshashimei" :disabled="tatakkengyoshajoho.tatakkengyoshajoho_keiyasho_hoshajoho_hyojishinai === false || torihiki_taiyo_tatakkengyosha_shasenhiki === true"/>
                    <span class="tooltip-custom" :class="addPadding(`tatakkengyoshajoho.daihyoshashimei.${index}`)">{{showMaxlength(20, tatakkengyoshajoho.daihyoshashimei, `tatakkengyoshajoho.daihyoshashimei.${index}`)}}</span>
                  </td>
                </tr>
                <tr>
                  <td style="width: 15%" rowspan="4">
                    <span class="self-center">事業所情報※(上段)代表者、もしくは(下段)店長以外が押印する場合必要</span>
                  </td>
                  <td style="width: 15%" class="border-bottom-none border-right-none">
                    <span>住所</span>
                  </td>
                  <td class="border-bottom-none border-left-none">
                    <vs-input @blur="focusOut()" @focus="onFocus(`tatakkengyoshajoho.tenpojoho_jusho.${index}`)" class="w-11/12" maxlength="76" v-model="tatakkengyoshajoho.tenpojoho_jusho" :disabled="torihiki_taiyo_tatakkengyosha_shasenhiki === true"/>
                    <span class="tooltip-custom" :class="addPadding(`tatakkengyoshajoho.tenpojoho_jusho.${index}`)">{{showMaxlength(76, tatakkengyoshajoho.tenpojoho_jusho, `tatakkengyoshajoho.tenpojoho_jusho.${index}`)}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="border-top-none border-right-none border-bottom-none">
                    <span>事業所名・部門名</span>
                  </td>
                  <td class="border-top-none border-left-none border-bottom-none">
                    <vs-input @blur="focusOut()" @focus="onFocus(`tatakkengyoshajoho.tenpojoho_jimushomei.${index}`)" class="w-11/12" maxlength="38" v-model="tatakkengyoshajoho.tenpojoho_jimushomei" :disabled="torihiki_taiyo_tatakkengyosha_shasenhiki === true"/>
                    <span class="tooltip-custom" :class="addPadding(`tatakkengyoshajoho.tenpojoho_jimushomei.${index}`)">{{showMaxlength(38, tatakkengyoshajoho.tenpojoho_jimushomei, `tatakkengyoshajoho.tenpojoho_jimushomei.${index}`)}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="border-top-none border-right-none border-bottom-none">
                    <span class="mt-2">役職</span>
                  </td>
                  <td class="border-top-none border-left-none border-bottom-none">
                    <vs-input @blur="focusOut()" @focus="onFocus(`tatakkengyoshajoho.tenpojoho_yakushoku.${index}`)" class="w-11/12" maxlength="17" v-model="tatakkengyoshajoho.tenpojoho_yakushoku" :disabled="torihiki_taiyo_tatakkengyosha_shasenhiki === true"/>
                    <span class="tooltip-custom" :class="addPadding(`tatakkengyoshajoho.tenpojoho_yakushoku.${index}`)">{{showMaxlength(17, tatakkengyoshajoho.tenpojoho_yakushoku, `tatakkengyoshajoho.tenpojoho_yakushoku.${index}`)}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="border-top-none border-right-none">
                    <span >事業所長名・部門長名</span>
                  </td>
                  <td class="border-top-none border-left-none">
                    <vs-input @blur="focusOut()" @focus="onFocus(`tatakkengyoshajoho.tenpojoho_jimushochona.${index}`)" class="w-11/12" maxlength="20" v-model="tatakkengyoshajoho.tenpojoho_jimushochona" :disabled="torihiki_taiyo_tatakkengyosha_shasenhiki === true"/>
                    <span class="tooltip-custom" :class="addPadding(`tatakkengyoshajoho.tenpojoho_jimushochona.${index}`)">{{showMaxlength(20, tatakkengyoshajoho.tenpojoho_jimushochona, `tatakkengyoshajoho.tenpojoho_jimushochona.${index}`)}}</span>
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    <span class="mr-16 self-center">説明をする宅地建物取引士</span>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="width: 280px" class="border-bottom-none border-right-none">
                    <span>登録番号</span>
                  </td>
                  <td class="border-bottom-none border-left-none">
                    <vs-input class="w-11/12" v-model="tatakkengyoshajoho.setsumei_torihikishi_torokubango" maxlength="38" @blur="lostFocus, focusOut()" @focus="onFocus(`tatakkengyoshajoho.setsumei_torihikishi_torokubango.${index}`)" :disabled="torihiki_taiyo_tatakkengyosha_shasenhiki === true"/>
                    <span class="tooltip-custom" :class="addPadding(`tatakkengyoshajoho.setsumei_torihikishi_torokubango.${index}`)">{{showMaxlength(38, tatakkengyoshajoho.setsumei_torihikishi_torokubango, `tatakkengyoshajoho.setsumei_torihikishi_torokubango.${index}`)}}</span>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="border-top-none border-right-none">
                    <span>氏名</span>
                  </td>
                  <td class="border-top-none border-left-none">
                    <vs-input class="w-11/12" v-model="tatakkengyoshajoho.setsumei_torihikishi_shimei" @blur="focusOut()" @focus="onFocus(`tatakkengyoshajoho.setsumei_torihikishi_shimei.${index}`)"  maxlength="38" :disabled="torihiki_taiyo_tatakkengyosha_shasenhiki === true"/>
                    <span class="tooltip-custom" :class="addPadding(`tatakkengyoshajoho.setsumei_torihikishi_shimei.${index}`)">{{showMaxlength(38, tatakkengyoshajoho.setsumei_torihikishi_shimei, `tatakkengyoshajoho.setsumei_torihikishi_shimei.${index}`)}}</span>
                  </td>
                </tr>
              </table>
            </tr>
            <tr>
              <div class="flex justify-end py-1">
                <vs-button class="primary mr-4 btn-positive" :disabled="tatakkengyoshajohoInputs.length >= 2 || torihiki_taiyo_tatakkengyosha_shasenhiki === true" @click="addNote(6)">他宅建業者情報追加</vs-button>
                <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="handleDeleteItem('tatakkengyoshajoho')">他宅建業者情報削除</vs-button>
              </div>
            </tr>
          </table>
        </div>
      </vx-card>
      <footer-button @cancel="popupActiveCancelForm = true"
                     @save="checkSave">
      </footer-button>

      <!-- Popup Delete Note -->
      <vs-popup
        class="holamundo"
        title="削除"
        :active.sync="popupActiveDeleteNote"
        :button-close-hidden="true"
      >
        <p class="my-4 font-bold text-lg">
          選択された項目を削除します。よろしいですか？
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleDeleteNote"
            >はい</vs-button>
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveDeleteNote = false"
            >いいえ</vs-button>
        </div>
      </vs-popup>

      <!-- Popup Cancel -->
      <vs-popup class="holamundo"
                title="キャンセル"
                :active.sync="popupActiveCancelForm"
                :button-close-hidden="true">
        <p class="my-4 font-bold text-lg">{{messageWhenCancel}}</p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleCancelSaveBSC">はい</vs-button>
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveCancelForm = false">いいえ</vs-button>
        </div>
      </vs-popup>
      <!-- Popup Clear All Tatakkengyoshajoho -->
                <vs-popup class="holamundo" title="クリア" :active.sync="popupActiveClearAllTatakkengyoshajoho" :button-close-hidden="true">
                    <p class="my-4 font-bold text-lg">{{messageWhenClear}}</p>
                    <div class="flex justify-end">
                      <vs-button class="mr-8 btn-positive btn-yes" @click="ClearDataTatakkengyoshajoho">はい</vs-button>
                      <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveClearAllTatakkengyoshajoho = false">いいえ</vs-button>
                    </div>
                </vs-popup>

      <!-- Popup Save -->
      <vs-popup class="holamundo"
                title="保存"
                :active.sync="popupActiveSaveForm"
                :button-close-hidden="true">
        <p class="my-4 font-bold text-lg">{{messageWhenHanei}}</p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleSaveBSC">はい</vs-button>
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveSaveForm = false">いいえ</vs-button>
        </div>
      </vs-popup>

      <!-- Popup Error -->
                <vs-popup class="holamundo"
                          title="保存"
                          :active.sync="popupFormError"
                          :button-close-hidden="true">
                  <p class="my-4 font-bold text-lg">
                    {{globalErrorMessage}}
                  </p>
                  <div class="flex justify-end">
                    <vs-button class="btn-positive btn-yes" color="positive" type="filled" text-color="#7367F0" @click="popupFormError = false">はい</vs-button>
                  </div>
                </vs-popup>
    </div>
    <Transition name="baikei-transition">
    <vx-card class="vx-col mb-base comment-frame" id="closeCommentSiderPattern" :class="isShowComment ? 'closeComment': 'showComment'" >
      <Comment @tickPart="tickPart" @showHightlightInPage="handleShowHightlightInPage" @closeCommentSiderPattern="handleCloseCommentSiderPage" @commentData="getArrayHighlight" :pattern="bscPattern"/>
    </vx-card>
    </Transition>
  </div>
</template>

<script>
import _ from 'lodash'
import vSelect from 'vue-select'
import json from '../jsons-data/options.json'
import DatePickerCustom from '../components/DatePickerCustom.vue'
import BunshoTemplate from './components/BunshoTemplate.vue'
import FooterButton from './components/FooterButton.vue'
import RadioBox from './components/RadioBox.vue'
import { SAVE_BSC, SAVE_JTM, SAVE_EDIT_MODE, SAVE_KEIYAKU } from '@/store/modules/keiyaku/actions.js'
import { MESSAGE } from '../constant/message_code'
import routeIfCodeNull from '@/mixins/routeIfCodeNull'
import utilitiesMethods from '@/mixins/utilitiesMethods'
import { GET_TAKKENSHI_INFO } from '../store/modules/keiyaku/actions'
import LeftPreviewSlider from './components/LeftPreviewSlider.vue'
import Comment from './comment'
import { bsc01Highlight, bsc02Highlight, bsc03Highlight, idBaikeiGeneralComment_l1 } from '../constant/highlight'
import DragBlackIcon from '@/assets/images/icons/DragBlackIcon.vue'
import draggable from 'vuedraggable'
import highlighter from '../mixins/highlighter'
export default {
  name: 'BSC',
  mixins: [routeIfCodeNull, utilitiesMethods, highlighter],
  components: {
    vSelect,
    DatePickerCustom,
    BunshoTemplate,
    FooterButton,
    RadioBox,
    DragBlackIcon,
    draggable,
    LeftPreviewSlider,
    Comment
  },

  data() {
    return {
      arrayCommentId: [],
      arrayHighlightId: [],
      selectOptions301: [],
      selectOptions57: [],
      selectOptions58: [],
      isShowComment: true,
      isOpenPreview: true,
      clearData: null,
      popupActiveClearAllTatakkengyoshajoho: false,
      attentionWaringStatus: false,
      globalErrorMessage: MESSAGE.M1023,
      messageWhenCancel: MESSAGE.M1008,
      messageWhenHanei: MESSAGE.M1007,
      messageWhenClear: MESSAGE.M1011,
      // response
      myJson: json,
      //
      kozotairyoku_kakuninjiko: null,
      kainushi_urinushi_soho_kakuninjiko: null,

      keiyakufutekigo_rikosochi1: false,
      keiyakufutekigo_rikosochi2: false,
      torihiki_taiyo_tatakkengyosha_shasenhiki: false,
      seisankijunbi: null,

      honkeiyaku_tekisetsu_nengappi: '',
      honkeiyaku_tekisetsu_nengappi_checkbox: false,

      jisha_menkyoshobango: null,
      jisha_shutaru_jimusho_shozaichi: null,
      jisha_daihyoshayakusho: null,
      jisha_daihyoshashimei: null,
      jisha_shogo: '',
      wakaregyoshajoho_keiyasho_hoshajoho_hyojishinai: true,

      jisha_tenpojoho_jusho: '',
      jisha_tenpojoho_jimushomei: '',
      jisha_tenpojoho_yakushoku: '',
      jisha_tenpojoho_jimushochona: '',

      jisha_setsumei_eigyohoshokin_kyotaku_meisho: '',
      jisha_setsumei_eigyohoshokin_kyotaku_shozaichi: '',

      torihikishi2_torokubango: '',
      torihikishi2_shimei: '',

      firstUrinushishomeiInputs: {
        checkboxDelete: false,
        jusho: '',
        shimei: '',
        urinushi_type: '売主',
        sonohoka_type: '',
        baikei_insatsushinai: false
      },
      urinushishomeiInputs: [],
      urinushishomeiInputsIndex: [],
      firstKainushishomeiInputs: {
        checkboxDelete: false,
        jusho: '',
        shimei: '',
        kainushi_type: '買主',
        sonohoka_type: '',
        baikei_insatsushinai: false
      },
      kainushishomeiInputs: [],
      kainushishomeiInputsIndex: [],
      urinushi: '',
      kainushi: '',
      urinushi_chuoyose: false,
      kainushi_chuoyose: false,
      urinushishomei_chuoyose: false,
      kainushishomei_chuoyose: false,

      selectOptions311: [],
      popupActiveDeleteNote: false,
      popupActiveSaveForm: false,
      popupActiveCancelForm: false,
      popupFormError: false,
      selectedDeleteItem: null,
      // kainushi_urinushi_soho_kakuninjiko_biko
      kainushi_urinushi_soho_kakuninjiko_bikoInputs: [
        {
          checkboxDelete: false,
          kainushi_urinushi_soho_kakuninjiko_biko: ''
        }
      ],
      // keiyakufutekigo_rikosochi_biko
      keiyakufutekigo_rikosochi_bikoInputs: [
        {
          checkboxDelete: false,
          keiyakufutekigo_rikosochi_biko: ''
        }
      ],
      // tokuyaku
      tokuyakuInputs: [
        {
          ikabesshi: false,
          checkboxDelete: false,
          tokuyaku: ''
        }
      ],
      tatakkengyoshajohoInputs:[
        {
          keiyakusho_tachiai_iran_hyojishinai: false,
          tatakkengyoshajoho_keiyasho_hoshajoho_hyojishinai: true,
          // torihiki_taiyo_tatakkengyosha_shasenhiki: false,
          checkboxDelete: false,
          menkyoshobango: '',
          shogo: '',
          shutaru_jimusho_shozaichi: '',
          daihyoshayakusho: '',
          daihyoshashimei: '',
          oinkenyakusho: '',
          oinkenshashimei: '',
          tenpojoho_jusho: '',
          tenpojoho_jimushomei: '',
          tenpojoho_yakushoku: '',
          tenpojoho_jimushochona: '',
          setsumei_torihikishi_torokubango: '',
          setsumei_torihikishi_shimei: '',
          torihikitaiyo: '',
          kyotakusho_setsumei: null,
          kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_meisho: '',
          kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_shozaichi: '',
          kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_meisho: '',
          kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_jusho: '',
          kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_meisho: '',
          kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_shozaichi: '',
          kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_meisho: '',
          kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_shozaichi: ''
        }
      ],
      formValidation: {
        kozotairyoku_kakuninjiko: {
          patterns: ['bsc-02'],
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: true
        },
        kainushi_urinushi_soho_kakuninjiko: {
          patterns: ['bsc-02'],
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: () => {
            return (this.kozotairyoku_kakuninjiko === '0') && (this.kainushi_urinushi_soho_kakuninjiko === null)
          }
        },
        keiyakufutekigo_rikosochi1: {
          patterns: ['bsc-03'],
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: true
        },
        keiyakufutekigo_rikosochi2: {
          patterns: ['bsc-03'],
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: true
        },
        seisankijunbi: {
          errorMsg: MESSAGE.E6033,
          isError: false,
          error: () => {
            return !this.seisankijunbi
          }
        },
        urinushi: {
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: true
        },
        kainushi: {
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: true
        },
        jisha_shogo: {
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: () => {
            return !this.jisha_shogo
          }
        },
        jisha_shutaru_jimusho_shozaichi: {
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: () => {
            return !this.jisha_shutaru_jimusho_shozaichi
          }
        },
        jisha_daihyoshayakusho: {
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: () => {
            return !this.jisha_daihyoshayakusho
          }
        },
        jisha_daihyoshashimei: {
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: () => {
            return !this.jisha_daihyoshashimei
          }
        },
        // jisha_setsumei_eigyohoshokin_kyotaku_meisho: {
        //   warningMsg: MESSAGE.E8051,
        //   isWarning: false,
        //   warning: () => {
        //     return !this.jisha_setsumei_eigyohoshokin_kyotaku_meisho
        //   }
        // },
        // jisha_setsumei_eigyohoshokin_kyotaku_shozaichi: {
        //   warningMsg: MESSAGE.E8051,
        //   isWarning: false,
        //   warning: () => {
        //     return !this.jisha_setsumei_eigyohoshokin_kyotaku_shozaichi
        //   }
        // },
        torihikishi2_shimei: {
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: () => {
            return !this.torihikishi2_shimei
          }
        },
        jisha_tenpojoho_jusho: {
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: true
        },
        jisha_tenpojoho_jimushomei: {
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: true
        },
        jisha_tenpojoho_yakushoku: {
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: true
        },
        jisha_tenpojoho_jimushochona: {
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: true
        },
        torihikishi2_torokubango: {
          warningMsg: MESSAGE.E8051,
          isWarning: false,
          warning: () => {
            return !this.torihikishi2_torokubango
          }
        },
        honkeiyaku_tekisetsu_nengappi: {
          // warning: () => {
          //   this.formValidation.honkeiyaku_tekisetsu_nengappi.attentionWarning = false
          //   if (this.isNinetyDayAfterFiveYears(this.honkeiyaku_tekisetsu_nengappi) &&  !this.isFiveYear(this.honkeiyaku_tekisetsu_nengappi)) {
          //     this.formValidation.honkeiyaku_tekisetsu_nengappi.isError = false
          //     this.formValidation.honkeiyaku_tekisetsu_nengappi.warningMsg = MESSAGE.W4002
          //   }
          //   if (!this.honkeiyaku_tekisetsu_nengappi) {
          //     this.formValidation.honkeiyaku_tekisetsu_nengappi.isError = false
          //     this.formValidation.honkeiyaku_tekisetsu_nengappi.warningMsg = MESSAGE.E8051
          //   }
          //   return !this.honkeiyaku_tekisetsu_nengappi || (this.isNinetyDayAfterFiveYears(this.honkeiyaku_tekisetsu_nengappi) && !this.isFiveYear(this.honkeiyaku_tekisetsu_nengappi))
          // },
          error: () => {
            if(this.honkeiyaku_tekisetsu_nengappi) {
              if(!this.isValidDate(this.honkeiyaku_tekisetsu_nengappi)) {
                this.formValidation.honkeiyaku_tekisetsu_nengappi.isWarning = false
                this.formValidation.honkeiyaku_tekisetsu_nengappi.errorMsg = MESSAGE.E6014
              }
              // if(this.isFiveYear(this.honkeiyaku_tekisetsu_nengappi)) {
              //   this.formValidation.honkeiyaku_tekisetsu_nengappi.isWarning = false
              //   this.formValidation.honkeiyaku_tekisetsu_nengappi.errorMsg = MESSAGE.E6022
              // }
            }
            return this.honkeiyaku_tekisetsu_nengappi && !this.isValidDate(this.honkeiyaku_tekisetsu_nengappi)
          },
          attentionWarning: false,
          isError: false,
          errorMsg: '',
          isWarning: false,
          warningMsg: MESSAGE.E8051
        }
        // tatakkengyoshajohoInputs: {
        //   warningMsg: MESSAGE.E8051,
        //   isWarning: false,
        //   warning: () => {

        //   }
        // }
      },
      hasWarning: false,
      checkValidate: false,
      tokuyaku_matsubi_ikayohaku_hyoji: true,
      tokuyaku_numbering: true,
      kainushi_urinushi_soho_kakuninjiko_matsubi_ikayohaku_hyoji: true,
      kainushi_urinushi_soho_kakuninjiko_numbering: true,
      keiyakufutekigo_rikosochi_biko_matsubi_ikayohaku_hyoji: true,
      keiyakufutekigo_rikosochi_biko_numbering: true
    }
  },
  mounted() {
    this.getStyleForEditScreen()
    this.handleGetCommentId()
    this.isShowComment = this.getStateShowComment
    this.isOpenPreview = this.getLeftPreviewSliderStatus
    this.selectOptions311 = this.myJson._311.values
    this.selectOptions301 = this.myJson._56.values
    this.selectOptions57 = this.myJson._57.values
    this.selectOptions58 = this.myJson._58.values
    const duplicateStatus = this.$store.getters.getDuplicateStatus
    if(this.bscData !== null) {
      const bsc = this.bscData
      this.kozotairyoku_kakuninjiko = bsc.kozotairyoku_kakuninjiko
      this.kainushi_urinushi_soho_kakuninjiko = bsc.kainushi_urinushi_soho_kakuninjiko

      // kainushi_urinushi_soho_kakuninjiko_biko
      if (Array.isArray(bsc.kainushi_urinushi_soho_kakuninjiko_biko)) {
        this.kainushi_urinushi_soho_kakuninjiko_bikoInputs = bsc.kainushi_urinushi_soho_kakuninjiko_biko.map(item => {
          return {
            checkboxDelete: false,
            kainushi_urinushi_soho_kakuninjiko_biko: item
          }
        })
      }
      //
      this.keiyakufutekigo_rikosochi1 = bsc.keiyakufutekigo_rikosochi1
      this.keiyakufutekigo_rikosochi2 = bsc.keiyakufutekigo_rikosochi2
      // keiyakufutekigo_rikosochi_biko
      if (Array.isArray(bsc.keiyakufutekigo_rikosochi_biko)) {
        this.keiyakufutekigo_rikosochi_bikoInputs = bsc.keiyakufutekigo_rikosochi_biko.map(item => {
          return {
            checkboxDelete: false,
            keiyakufutekigo_rikosochi_biko: item
          }
        })
      }
      //
      this.seisankijunbi = bsc.seisankijunbi
      if (Array.isArray(bsc.tokuyaku)) {
        this.tokuyakuInputs = bsc.tokuyaku.map(item => {
          item.checkboxDelete = false
          return item
        })
      }
      //
      this.urinushi = bsc.urinushi
      this.kainushi = bsc.kainushi
      this.urinushi_chuoyose = bsc.urinushi_chuoyose === undefined ? false : bsc.urinushi_chuoyose
      this.kainushi_chuoyose = bsc.kainushi_chuoyose === undefined ? false : bsc.kainushi_chuoyose
      this.urinushishomei_chuoyose = bsc.urinushishomei_chuoyose === undefined ? false : bsc.urinushishomei_chuoyose
      this.kainushishomei_chuoyose = bsc.kainushishomei_chuoyose === undefined ? false : bsc.kainushishomei_chuoyose
      this.honkeiyaku_tekisetsu_nengappi = bsc.honkeiyaku_tekisetsu_nengappi
      this.honkeiyaku_tekisetsu_nengappi_checkbox = bsc.honkeiyaku_tekisetsu_nengappi_checkbox
      // urinushishomei
      if (Array.isArray(bsc.urinushishomei)) {
        this.firstUrinushishomeiInputs = bsc.urinushishomei[0]
        if(bsc.urinushishomei.length > 1) {
          this.urinushishomeiInputs = bsc.urinushishomei.slice(1).map(item => {
            item.baikei_insatsushinai = item.baikei_insatsushinai ? item.baikei_insatsushinai : false
            item.urinushi_type = item.urinushi_type ? item.urinushi_type : '売主'
            item.sonohoka_type = item.sonohoka_type ? item.sonohoka_type : ''
            item.checkboxDelete = false
            return item
          })
        }
      }
      if (Array.isArray(bsc.kainushishomei)) {
        this.firstKainushishomeiInputs = bsc.kainushishomei[0]
        if(bsc.kainushishomei.length > 1) {
          this.kainushishomeiInputs = bsc.kainushishomei.slice(1).map(item => {
            item.baikei_insatsushinai = item.baikei_insatsushinai ? item.baikei_insatsushinai : false
            item.kainushi_type = item.kainushi_type ? item.kainushi_type : '買主'
            item.sonohoka_type = item.sonohoka_type ? item.sonohoka_type : ''
            item.checkboxDelete = false
            return item
          })
        }
      }
      // Takkenshi
      this.jisha_menkyoshobango = bsc.jisha_menkyoshobango
      this.jisha_shutaru_jimusho_shozaichi = bsc.jisha_shutaru_jimusho_shozaichi
      this.jisha_daihyoshayakusho = bsc.jisha_daihyoshayakusho
      this.jisha_daihyoshashimei = bsc.jisha_daihyoshashimei
      this.jisha_shogo = bsc.jisha_shogo
      this.wakaregyoshajoho_keiyasho_hoshajoho_hyojishinai = bsc.wakaregyoshajoho_keiyasho_hoshajoho_hyojishinai === undefined ? true : bsc.wakaregyoshajoho_keiyasho_hoshajoho_hyojishinai
      this.jisha_tenpojoho_jusho = bsc.jisha_tenpojoho_jusho
      this.jisha_tenpojoho_jimushomei = bsc.jisha_tenpojoho_jimushomei
      this.jisha_tenpojoho_yakushoku = bsc.jisha_tenpojoho_yakushoku
      this.jisha_tenpojoho_jimushochona = bsc.jisha_tenpojoho_jimushochona
      if(bsc.torihikishi2_torokubango === undefined && bsc.torihikishi2_shimei === undefined) {
        const { officeGlobalId } = this.$route.params
        this.$store.dispatch(GET_TAKKENSHI_INFO, officeGlobalId).then(
          (takenshi) => {
            if (takenshi) {
              this.torihikishi2_torokubango = takenshi.torihikishi2_torokubango
              this.torihikishi2_shimei = takenshi.torihikishi2_shimei
            }
          })
          .catch((error) => {
            const messageErrorCode = error.data.error.code
            if(messageErrorCode === 'UNAUTHORIZED') {
              this.$router.push('/pages/not-authorized')
            }
          })
      } else {
        this.torihikishi2_torokubango = bsc.torihikishi2_torokubango
        this.torihikishi2_shimei = bsc.torihikishi2_shimei
      }
  
      this.jisha_setsumei_eigyohoshokin_kyotaku_meisho = bsc.jisha_setsumei_eigyohoshokin_kyotaku_meisho
      this.jisha_setsumei_eigyohoshokin_kyotaku_shozaichi = bsc.jisha_setsumei_eigyohoshokin_kyotaku_shozaichi

      if (Array.isArray(bsc.tatakkengyoshajoho)) {
        this.tatakkengyoshajohoInputs = bsc.tatakkengyoshajoho.map(item => {
          item.checkboxDelete = false
          return item
        })
      }
      if(this.jtmData && this.jtmData.torihiki_taiyo_tatakkengyosha_shasenhiki !== undefined) {
        this.torihiki_taiyo_tatakkengyosha_shasenhiki = this.jtmData.torihiki_taiyo_tatakkengyosha_shasenhiki
      }

      // this.tatakkengyoshajohoInputs[0].torihiki_taiyo_tatakkengyosha_shasenhiki = bsc.torihiki_taiyo_tatakkengyosha_shasenhiki === undefined ? false : bsc.torihiki_taiyo_tatakkengyosha_shasenhiki
      // if(this.tatakkengyoshajohoInputs.length > 1) {
      //   this.tatakkengyoshajohoInputs[1].torihiki_taiyo_tatakkengyosha_shasenhiki = bsc.torihiki_taiyo_tatakkengyosha_shasenhiki === undefined ? false : bsc.torihiki_taiyo_tatakkengyosha_shasenhiki
      // }
      
      this.tokuyaku_matsubi_ikayohaku_hyoji = bsc.tokuyaku_matsubi_ikayohaku_hyoji === undefined ? true : bsc.tokuyaku_matsubi_ikayohaku_hyoji
      this.tokuyaku_numbering = bsc.tokuyaku_numbering === undefined ? true : bsc.tokuyaku_numbering
      this.kainushi_urinushi_soho_kakuninjiko_matsubi_ikayohaku_hyoji = bsc.kainushi_urinushi_soho_kakuninjiko_matsubi_ikayohaku_hyoji === undefined ? true : bsc.kainushi_urinushi_soho_kakuninjiko_matsubi_ikayohaku_hyoji
      this.kainushi_urinushi_soho_kakuninjiko_numbering = bsc.kainushi_urinushi_soho_kakuninjiko_numbering === undefined ? true : bsc.kainushi_urinushi_soho_kakuninjiko_numbering
      this.keiyakufutekigo_rikosochi_biko_matsubi_ikayohaku_hyoji = bsc.keiyakufutekigo_rikosochi_biko_matsubi_ikayohaku_hyoji === undefined ? true : bsc.keiyakufutekigo_rikosochi_biko_matsubi_ikayohaku_hyoji
      this.keiyakufutekigo_rikosochi_biko_numbering = bsc.keiyakufutekigo_rikosochi_biko_numbering === undefined ? true : bsc.keiyakufutekigo_rikosochi_biko_numbering
    }

    if (!this.jtmData || duplicateStatus) {
      this.getTakkenshiData()
    }

    const editMode = _.get(this.$store.getters.editMode, 'bsc', false)
    if (editMode) {
      setTimeout(() => {
        this.validateWarning()
      }, 500)
    }
  },
  computed: {
    getStateShowComment() {
      return this.$store.getters.getStateShowComment
    },
    getLeftPreviewSliderStatus() {
      return this.$store.getters.getLeftPreviewSliderStatus
    },
    bscData() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'baikei.bsc', null))
    },
    bscPattern() {
      return _.get(this.$store.getters.pattern, 'baikei.bsc', null)
    },
    jtmPattern() {
      return _.get(this.$store.getters.pattern, 'jusetsu.jtm', null)
    },
    jtmData() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'jusetsu.jtm', null))
    },
    jrb07_09_Data() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'jusetsu.jrb07_09', null))
    },
    kainushishomeiInputTotal() {
      return [this.firstKainushishomeiInputs, ...this.kainushishomeiInputs]
    },
    urinushishomeiInputTotal() {
      return [this.firstUrinushishomeiInputs, ...this.urinushishomeiInputs]
    }
  },
  watch: {
    '$store.getters.getStateShowComment' (val) {
      this.isShowComment = val
    },
    '$store.getters.getLeftPreviewSliderStatus' (val) {
      this.isOpenPreview = val
    },
    urinushishomeiInputs: {
      handler: 'handleAddIndexUrinushi',
      deep: true
    },
    kainushishomeiInputs:{
      handler: 'handleAddIndexKainushi',
      deep: true
    }
  },
  methods: {
    getArrayHighlight(data) {
      const idElement = []
      const block_list = data.block_list
      block_list.forEach(item => {
        item.part_list.map(ele => {
          idElement.push(ele.id_element)
        })
      })
      this.arrayHighlightId = idElement.filter(item => item.includes('bsc'))
    },
    handleGetCommentId() {
      let bscPatternHighlight = []
      switch (this.bscPattern) {
      case 'bsc-01':
        bscPatternHighlight = bsc01Highlight
        break
      case 'bsc-02':
        bscPatternHighlight = bsc02Highlight
        break
      case 'bsc-03':
        bscPatternHighlight = bsc03Highlight
        break
      default:
        break
      }
      let index = 0
      const bscHighlight = bscPatternHighlight.map(item => {
        if(item) {
          index = index + 1
          item = `${this.bscPattern}-${index}`
        }
        return item
      })
      this.arrayCommentId = bscHighlight
    },
    handleCheck(type) {
      switch (type) {
      case 'kozotairyoku_kakuninjiko':
        if(this.kozotairyoku_kakuninjiko !== '0') {
          this.kainushi_urinushi_soho_kakuninjiko = null
        }
        break
      }
    },
    addNote(type) {
      if (type === 1) {
        this.kainushi_urinushi_soho_kakuninjiko_bikoInputs.push({
          checkboxDelete: false
        })
      }
      if (type === 2) {
        this.keiyakufutekigo_rikosochi_bikoInputs.push({
          checkboxDelete: false
        })
      }
      if (type === 3) {
        this.tokuyakuInputs.push({
          ikabesshi: false,
          checkboxDelete: false,
          tokuyaku: ''
        })
      }
      if (type === 4) {
        this.urinushishomeiInputs.push({
          checkboxDelete: false,
          jusho: '',
          shimei: '',
          urinushi_type: '売主',
          sonohoka_type: '',
          baikei_insatsushinai: false
        })
      }
      if (type === 5) {
        this.kainushishomeiInputs.push({
          checkboxDelete: false,
          jusho: '',
          shimei: '',
          kainushi_type: '買主',
          sonohoka_type: '',
          baikei_insatsushinai: false
        })
      }
      if (type === 6) {
        this.tatakkengyoshajohoInputs.push({
          checkboxDelete: false,
          menkyoshobango: '',
          shogo: '',
          shutaru_jimusho_shozaichi: '',
          daihyoshayakusho: '',
          daihyoshashimei: '',
          oinkenyakusho: '',
          oinkenshashimei: '',
          tenpojoho_jusho: '',
          tenpojoho_jimushomei: '',
          tenpojoho_yakushoku: '',
          tenpojoho_jimushochona: '',
          setsumei_torihikishi_torokubango: '',
          setsumei_torihikishi_shimei: '',
          tatakkengyoshajoho_keiyasho_hoshajoho_hyojishinai: true,
          keiyakusho_tachiai_iran_hyojishinai: false,
          torihikitaiyo: '',
          kyotakusho_setsumei: null,
          kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_meisho: '',
          kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_shozaichi: '',
          kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_meisho: '',
          kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_jusho: '',
          kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_meisho: '',
          kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_shozaichi: '',
          kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_meisho: '',
          kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_shozaichi: ''
        })
      }
    },
    handleDeleteNote() {
      if (this.selectedDeleteItem === 1) {
        this.kainushi_urinushi_soho_kakuninjiko_bikoInputs = this.kainushi_urinushi_soho_kakuninjiko_bikoInputs.filter(v => !v.checkboxDelete)
        if(this.kainushi_urinushi_soho_kakuninjiko_bikoInputs.length === 0) {
          this.addNote(1)
        }
        this.selectedDeleteItem = null
        this.popupActiveDeleteNote = false
      }
      if (this.selectedDeleteItem === 2) {
        this.keiyakufutekigo_rikosochi_bikoInputs = this.keiyakufutekigo_rikosochi_bikoInputs.filter(v => !v.checkboxDelete)
        if(this.keiyakufutekigo_rikosochi_bikoInputs.length === 0) {
          this.addNote(2)
        }
        this.selectedDeleteItem = null
        this.popupActiveDeleteNote = false
      }
      if (this.selectedDeleteItem === 3) {
        this.tokuyakuInputs = this.tokuyakuInputs.filter(v => !v.checkboxDelete)
        if(this.tokuyakuInputs.length === 0) {
          this.addNote(3)
        }
        this.selectedDeleteItem = null
        this.popupActiveDeleteNote = false
      }
      if (this.selectedDeleteItem === 4) {
        if(this.firstUrinushishomeiInputs.checkboxDelete === true) {
          const urinushishomeiDefault = {
            checkboxDelete: false,
            jusho: '',
            shimei: '',
            urinushi_type: '売主',
            sonohoka_type: '',
            baikei_insatsushinai: false
          }
          this.firstUrinushishomeiInputs = urinushishomeiDefault
        }
        this.urinushishomeiInputs = this.urinushishomeiInputs.filter(v => !v.checkboxDelete)
        // if(this.urinushishomeiInputs.length === 0) {
        //   this.addNote(4)
        // }
        this.selectedDeleteItem = null
        this.popupActiveDeleteNote = false
      }
      if (this.selectedDeleteItem === 5) {
        if(this.firstKainushishomeiInputs.checkboxDelete === true) {
          const kainushishomeiDefault = {
            checkboxDelete: false,
            jusho: '',
            shimei: '',
            kainushi_type: '買主',
            sonohoka_type: '',
            baikei_insatsushinai: false
          }
          this.firstKainushishomeiInputs = kainushishomeiDefault
        }
        this.kainushishomeiInputs = this.kainushishomeiInputs.filter(v => !v.checkboxDelete)
        
        // if(this.kainushishomeiInputs.length === 0) {
        //   this.addNote(5)
        // }
        this.selectedDeleteItem = null
        this.popupActiveDeleteNote = false
      }
      if (this.selectedDeleteItem === 6) {
        this.tatakkengyoshajohoInputs = this.tatakkengyoshajohoInputs.filter(v => !v.checkboxDelete)
        if(this.tatakkengyoshajohoInputs.length === 0) {
          this.addNote(6)
        }
        this.selectedDeleteItem = null
        this.popupActiveDeleteNote = false
      }
    },


    ClearDataTatakkengyoshajoho() {
      this.tatakkengyoshajohoInputs[this.clearData].keiyakusho_tachiai_iran_hyojishinai =  false
      this.tatakkengyoshajohoInputs[this.clearData].tatakkengyoshajoho_keiyasho_hoshajoho_hyojishinai =  true
      this.tatakkengyoshajohoInputs[this.clearData].checkboxDelete = false
      this.tatakkengyoshajohoInputs[this.clearData].menkyoshobango =  ''
      this.tatakkengyoshajohoInputs[this.clearData].shogo =  ''
      this.tatakkengyoshajohoInputs[this.clearData].shutaru_jimusho_shozaichi =  ''
      this.tatakkengyoshajohoInputs[this.clearData].daihyoshayakusho =  ''
      this.tatakkengyoshajohoInputs[this.clearData].daihyoshashimei =  ''
      this.tatakkengyoshajohoInputs[this.clearData].oinkenyakusho =  ''
      this.tatakkengyoshajohoInputs[this.clearData].oinkenshashimei =  ''
      this.tatakkengyoshajohoInputs[this.clearData].tenpojoho_jusho =  ''
      this.tatakkengyoshajohoInputs[this.clearData].tenpojoho_jimushomei =  ''
      this.tatakkengyoshajohoInputs[this.clearData].tenpojoho_yakushoku =  ''
      this.tatakkengyoshajohoInputs[this.clearData].tenpojoho_jimushochona =  ''
      this.tatakkengyoshajohoInputs[this.clearData].setsumei_torihikishi_torokubango =  ''
      this.tatakkengyoshajohoInputs[this.clearData].setsumei_torihikishi_shimei =  ''
      this.popupActiveClearAllTatakkengyoshajoho = false
    },

    getTakkenshiData() {
      const { officeGlobalId } = this.$route.params
      this.$store.dispatch(GET_TAKKENSHI_INFO, officeGlobalId).then(
        (takenshi) => {
          if (takenshi) {
            this.jisha_menkyoshobango = takenshi.jisha_menkyoshobango
            this.jisha_shutaru_jimusho_shozaichi = takenshi.jisha_shutaru_jimusho_shozaichi
            this.jisha_daihyoshayakusho = takenshi.jisha_daihyoshayakusho
            this.jisha_daihyoshashimei = takenshi.jisha_daihyoshashimei
            this.jisha_shogo = takenshi.jisha_shogo
            this.jisha_tenpojoho_jusho = takenshi.jisha_tenpojoho_jusho
            this.jisha_tenpojoho_jimushomei = takenshi.jisha_tenpojoho_jimushomei
            this.jisha_tenpojoho_yakushoku = takenshi.jisha_tenpojoho_yakushoku
            this.jisha_tenpojoho_jimushochona = takenshi.jisha_tenpojoho_jimushochona
            this.torihikishi2_torokubango = takenshi.torihikishi2_torokubango
            this.torihikishi2_shimei = takenshi.torihikishi2_shimei
          }
        })
        .catch((error) => {
          const messageErrorCode = error.data.error.code
          if(messageErrorCode === 'UNAUTHORIZED') {
            this.$router.push('/pages/not-authorized')
          }
        })
    },

    CheckboxAll(check) {
      this.urinushishomeiInputs.map(item => { item.baikei_insatsushinai = check })
      this.kainushishomeiInputs.map(item => { item.baikei_insatsushinai = check })
      this.firstKainushishomeiInputs.baikei_insatsushinai = check
      this.firstUrinushishomeiInputs.baikei_insatsushinai = check
    },

    handleSaveBSC() {
      const handle = () => {
        const bsc = {
        //
          tokuyaku_matsubi_ikayohaku_hyoji: this.tokuyaku_matsubi_ikayohaku_hyoji,
          tokuyaku_numbering: this.tokuyaku_numbering,
          kainushi_urinushi_soho_kakuninjiko_matsubi_ikayohaku_hyoji: this.kainushi_urinushi_soho_kakuninjiko_matsubi_ikayohaku_hyoji,
          kainushi_urinushi_soho_kakuninjiko_numbering: this.kainushi_urinushi_soho_kakuninjiko_numbering,
          keiyakufutekigo_rikosochi_biko_matsubi_ikayohaku_hyoji: this.keiyakufutekigo_rikosochi_biko_matsubi_ikayohaku_hyoji,
          keiyakufutekigo_rikosochi_biko_numbering: this.keiyakufutekigo_rikosochi_biko_numbering,
          wakaregyoshajoho_keiyasho_hoshajoho_hyojishinai: this.wakaregyoshajoho_keiyasho_hoshajoho_hyojishinai,
          kozotairyoku_kakuninjiko: this.kozotairyoku_kakuninjiko,
          kainushi_urinushi_soho_kakuninjiko:
          this.kainushi_urinushi_soho_kakuninjiko,
          kainushi_urinushi_soho_kakuninjiko_biko:
          this.kainushi_urinushi_soho_kakuninjiko_bikoInputs.map((item) => {
            return item.kainushi_urinushi_soho_kakuninjiko_biko
          }),
          //
          keiyakufutekigo_rikosochi1: this.keiyakufutekigo_rikosochi1,
          keiyakufutekigo_rikosochi2: this.keiyakufutekigo_rikosochi2,
          keiyakufutekigo_rikosochi_biko: this.keiyakufutekigo_rikosochi_bikoInputs.map(item => {
            return item.keiyakufutekigo_rikosochi_biko
          }),
          //
          seisankijunbi: this.seisankijunbi,
          tokuyaku: this.tokuyakuInputs.map((item) => {
            const obj = Object.assign({}, item)
            delete obj.checkboxDelete
            return obj
          }),
          //
          urinushi: this.urinushi,
          kainushi: this.kainushi,
          urinushi_chuoyose: this.urinushi_chuoyose,
          kainushi_chuoyose: this.kainushi_chuoyose,
          urinushishomei_chuoyose: this.urinushishomei_chuoyose,
          kainushishomei_chuoyose: this.kainushishomei_chuoyose,
          honkeiyaku_tekisetsu_nengappi: this.honkeiyaku_tekisetsu_nengappi,
          honkeiyaku_tekisetsu_nengappi_checkbox: this.honkeiyaku_tekisetsu_nengappi_checkbox,

          urinushishomei: this.urinushishomeiInputTotal.map((item) => {
            const obj = Object.assign({}, item)
            delete obj.checkboxDelete
            return obj
          }),
          kainushishomei: this.kainushishomeiInputTotal.map((item) => {
            const obj = Object.assign({}, item)
            delete obj.checkboxDelete
            return obj
          }),

          // Same JTM
          jisha_menkyoshobango: this.jisha_menkyoshobango,
          jisha_shutaru_jimusho_shozaichi: this.jisha_shutaru_jimusho_shozaichi,
          jisha_daihyoshayakusho: this.jisha_daihyoshayakusho,
          jisha_daihyoshashimei: this.jisha_daihyoshashimei,
          jisha_shogo: this.jisha_shogo,

          jisha_tenpojoho_jusho: this.jisha_tenpojoho_jusho,
          jisha_tenpojoho_jimushomei: this.jisha_tenpojoho_jimushomei,
          jisha_tenpojoho_yakushoku: this.jisha_tenpojoho_yakushoku,
          jisha_tenpojoho_jimushochona: this.jisha_tenpojoho_jimushochona,

          jisha_setsumei_eigyohoshokin_kyotaku_meisho: this.jisha_setsumei_eigyohoshokin_kyotaku_meisho,
          jisha_setsumei_eigyohoshokin_kyotaku_shozaichi: this.jisha_setsumei_eigyohoshokin_kyotaku_shozaichi,

          torihikishi2_torokubango: this.torihikishi2_torokubango,
          torihikishi2_shimei: this.torihikishi2_shimei,
          torihiki_taiyo_tatakkengyosha_shasenhiki: this.bscData.torihiki_taiyo_tatakkengyosha_shasenhiki,
          tatakkengyoshajoho: this.tatakkengyoshajohoInputs.map((item) => {
            const obj = Object.assign({}, item)
            // item.torihiki_taiyo_tatakkengyosha_shasenhiki = this.bscData.torihiki_taiyo_tatakkengyosha_shasenhiki
            delete obj.checkboxDelete
            return obj
          })
        }

        const jtm = {
          jisha_menkyoshobango: this.jisha_menkyoshobango,
          jisha_shutaru_jimusho_shozaichi: this.jisha_shutaru_jimusho_shozaichi,
          jisha_daihyoshayakusho: this.jisha_daihyoshayakusho,
          jisha_daihyoshashimei: this.jisha_daihyoshashimei,
          jisha_shogo: this.jisha_shogo,

          jisha_tenpojoho_jusho: this.jisha_tenpojoho_jusho,
          jisha_tenpojoho_jimushomei: this.jisha_tenpojoho_jimushomei,
          jisha_tenpojoho_yakushoku: this.jisha_tenpojoho_yakushoku,
          jisha_tenpojoho_jimushochona: this.jisha_tenpojoho_jimushochona,

          jisha_setsumei_eigyohoshokin_kyotaku_meisho: this.jisha_setsumei_eigyohoshokin_kyotaku_meisho,
          jisha_setsumei_eigyohoshokin_kyotaku_shozaichi: this.jisha_setsumei_eigyohoshokin_kyotaku_shozaichi,

          torihikishi2_torokubango: this.torihikishi2_torokubango,
          torihikishi2_shimei: this.torihikishi2_shimei,

          tatakkengyoshajoho: this.tatakkengyoshajohoInputs.map((item) => {
            const obj = Object.assign({}, item)
            delete obj.checkboxDelete
            return obj
          })
        // baibainushijoho1:[],
        // baibainushijoho2:[]
        }
        // const length = this.urinushishomeiInputs.length >= this.kainushishomeiInputs.length ? this.urinushishomeiInputs.length : this.kainushishomeiInputs.length
        // for(let i = 0; i < length; i++) {
        //   jtm.baibainushijoho1.push({
        //     urinushi_jusho: '',
        //     urinushi_shimei: '',
        //     kainushi_jusho: '',
        //     kainushi_shimei: ''
        //   })
        // }
        // for(let i = 0; i < length; i++) {
        //   jtm.baibainushijoho1[i].urinushi_jusho = this.urinushishomeiInputs[i] ? this.urinushishomeiInputs[i].jusho : ''
        //   jtm.baibainushijoho1[i].urinushi_shimei = this.urinushishomeiInputs[i] ? this.urinushishomeiInputs[i].shimei : ''
        //   jtm.baibainushijoho1[i].kainushi_jusho = this.kainushishomeiInputs[i] ? this.kainushishomeiInputs[i].jusho : ''
        //   jtm.baibainushijoho1[i].kainushi_shimei = this.kainushishomeiInputs[i] ? this.kainushishomeiInputs[i].shimei : ''
        // }
        // for(let i = 0; i < length; i++) {
        //   jtm.baibainushijoho2.push({
        //     kainushi_jusho: '',
        //     kainushi_shimei: ''
        //   })
        // }
        // for(let i = 0; i < length; i++) {
        //   jtm.baibainushijoho2[i].kainushi_jusho = this.kainushishomeiInputs[i] ? this.kainushishomeiInputs[i].jusho : ''
        //   jtm.baibainushijoho2[i].kainushi_shimei = this.kainushishomeiInputs[i] ? this.kainushishomeiInputs[i].shimei : ''
        // }
        // const jrb07_09 = {
        // }
        // if(this.seisankijunbi === '0') {
        //   jrb07_09.koteishisanzei_kisanbi = this.myJson._55.values[1].value
        // } else if(this.seisankijunbi === '1') {
        //   jrb07_09.koteishisanzei_kisanbi = this.myJson._55.values[2].value
        // } else {
        //   jrb07_09.koteishisanzei_kisanbi = this.myJson._55.values[0].value
        // }
        // const biko = this.$store.getters.keiyaku.jusetsu.jrb07_09
        // if(!biko) {
        //   jrb07_09.biko2 = this.koteishisanzei(null, jrb07_09.koteishisanzei_kisanbi)
        // } else {
        //   jrb07_09.biko2 = this.koteishisanzei(biko.biko2, jrb07_09.koteishisanzei_kisanbi)
        // }
        const jtmData = _.merge(this.jtmData, jtm)
        jtmData.tatakkengyoshajoho = bsc.tatakkengyoshajoho
        // const jrb07_09_Data = _.merge(this.jrb07_09_Data, jrb07_09)
        this.$store.dispatch(SAVE_BSC, bsc).then(() => {
          this.$store.dispatch(SAVE_EDIT_MODE, {'bsc': true})
          // this.$store.dispatch(SAVE_JRB_M007_09, jrb07_09_Data)
          this.$store.dispatch(SAVE_JTM, jtmData).then(() => {
            this.$store.dispatch(SAVE_KEIYAKU).then(() => {
              this.popupActiveSaveForm = false
              setTimeout(() => {
                this.$router.push({name: 'baikei-m004-01'})
              }, 200)
            })
          })
        })
      }
      this.$store.commit('SET_DUPLICATE_CONTRACT', false)
      this.handleCheckCount(handle)
      this.popupActiveSaveForm = false
    },

    handleDeleteItem(type) {
      switch (type) {
      case 'kainushi':
        if (!this.kainushi_urinushi_soho_kakuninjiko_bikoInputs.filter(
          (element) => element.checkboxDelete === true).length) {
          this.$toasted.error('項目が選択されていません。')
          return
        }
        this.selectedDeleteItem = 1
        this.popupActiveDeleteNote = true
        break
      case 'keiyakufutekigo':
        if (!this.keiyakufutekigo_rikosochi_bikoInputs.filter(
          (element) => element.checkboxDelete === true).length) {
          this.$toasted.error('項目が選択されていません。')
          return
        }
        this.selectedDeleteItem = 2
        this.popupActiveDeleteNote = true
        break
      case 'tokuyaku':
        if (!this.tokuyakuInputs.filter(element => element.checkboxDelete === true).length) {
          this.$toasted.error('項目が選択されていません。')
          return
        }
        this.selectedDeleteItem = 3
        this.popupActiveDeleteNote = true
        break
      case 'urinushishomei':
        if (!this.urinushishomeiInputTotal.filter(element => element.checkboxDelete === true).length) {
          this.$toasted.error('項目が選択されていません。')
          return
        }
        this.selectedDeleteItem = 4
        this.popupActiveDeleteNote = true
        break
      case 'kainushishomei':
        if (!this.kainushishomeiInputTotal.filter(element => element.checkboxDelete === true).length) {
          this.$toasted.error('項目が選択されていません。')
          return
        }
        this.selectedDeleteItem = 5
        this.popupActiveDeleteNote = true
        break
      case 'tatakkengyoshajoho':
        if (!this.tatakkengyoshajohoInputs.filter(element => element.checkboxDelete === true).length) {
          this.$toasted.error('項目が選択されていません。')
          return
        }
        this.selectedDeleteItem = 6
        this.popupActiveDeleteNote = true
        break
      }
    },

    handleCancelSaveBSC() {
      this.handleSaveCountLocal()
      this.popupActiveCancelForm = false
      this.$nextTick(() => {
        this.$router.push({name: 'baikei-m004-01'})
      })
    },
    isNumber(value) {
      return value.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248)).replace(/\D/g, '')
    },
    highlight(key, isHighlight = true, eleIndex = null) {
      if (eleIndex === null) {
        // selectbox
        if (isHighlight) {
          $(`.v-select[name='${key}']`).find('.vs__dropdown-toggle').css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          $(`.v-select[name='${key}']`).find('.vs__dropdown-toggle').css({'background-color': 'inherit'})
        }
        // radiobox
        $('.con-vs-radio').each((idx, el) => {
          if ($(el).find(`input[name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-radio--borde').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-radio--borde').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // checkbox
        $('.con-vs-checkbox').each((idx, el) => {
          if ($(el).find(`input[vs-name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-checkbox').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-checkbox').css({'border-color': '#c8c8c8'})
            }
          } else if ($(el).find(`input[name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-checkbox').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-checkbox').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // vs-input
        const inputEl = $(`input[name='${key}']`)
        if (isHighlight) {
          inputEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          inputEl.css({'background-color': 'inherit'})
        }
        // vs-textarea
        const textareaEl = $(`textarea[name='${key}']`)
        if (isHighlight) {
          textareaEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          textareaEl.css({'background-color': 'inherit'})
        }
        // datepicker
        const selectEl = $(`div[datepicker='${key}']`).find('.vs__dropdown-toggle')
        const yearEl = $(`div[datepicker='${key}']`).find('input[name="year"]')
        const monthEl = $(`div[datepicker='${key}']`).find('input[name="month"]')
        const dayEl = $(`div[datepicker='${key}']`).find('input[name="day"]')
        if (isHighlight) {
          selectEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          yearEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          monthEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          dayEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          selectEl.css({'background-color': 'inherit'})
          yearEl.css({'background-color': 'inherit'})
          monthEl.css({'background-color': 'inherit'})
          dayEl.css({'background-color': 'inherit'})
        }
      } else {
        // selectbox
        const selectboxEl = $(`.v-select[name='${key}']`)
        if (selectboxEl.length) {
          if (isHighlight) {
            $(selectboxEl[eleIndex]).find('.vs__dropdown-toggle').css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(selectboxEl[eleIndex]).find('.vs__dropdown-toggle').css({'background-color': 'inherit'})
          }
        }
        // radiobox
        $('.con-vs-radio').each((idx, el) => {
          const radioEl = $(el).find(`input[name='${key}']`)
          if (radioEl.length && $(radioEl[eleIndex]).length) {
            if (isHighlight) {
              $(radioEl[eleIndex]).find('span.vs-radio--borde').css({'border-color': '#eea840'})
            } else {
              $(radioEl[eleIndex]).find('span.vs-radio--borde').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // vs-input
        const inputEl = $(`input[name='${key}']`)
        if (inputEl.length) {
          if (isHighlight) {
            $(inputEl[eleIndex]).css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(inputEl[eleIndex]).css({'background-color': 'inherit'})
          }
        }
        // vs-textarea
        const textareaEl = $(`textarea[name='${key}']`)
        if (textareaEl.length) {
          if (isHighlight) {
            $(textareaEl[eleIndex]).css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(textareaEl[eleIndex]).css({'background-color': 'inherit'})
          }
        }

        // datepicker
        if ($(`div[datepicker='${key}']`).length) {
          const selectEl = $($(`div[datepicker='${key}']`)[eleIndex]).find('.vs__dropdown-toggle')
          const yearEl = $($(`div[datepicker='${key}']`)[eleIndex]).find('input[name="year"]')
          const monthEl = $($(`div[datepicker='${key}']`)[eleIndex]).find('input[name="month"]')
          const dayEl = $($(`div[datepicker='${key}']`)[eleIndex]).find('input[name="day"]')
          if (isHighlight) {
            selectEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            yearEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            monthEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            dayEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            selectEl.css({'background-color': 'inherit'})
            yearEl.css({'background-color': 'inherit'})
            monthEl.css({'background-color': 'inherit'})
            dayEl.css({'background-color': 'inherit'})
          }
        }
      }
    },
    validateWarning() {
      const context = this
      this.hasWarning = false
      this.attentionWaringStatus = false
      Object.keys(this.formValidation).forEach(key => {
        this.formValidation[key].isWarning = false
        if (!this.formValidation[key].patterns || !this.formValidation[key].patterns.length
          || this.formValidation[key].patterns.includes(this.bscPattern)) {
          // ARRAY
          if (this.formValidation[key].elements) {
            this.formValidation[key].elements.forEach((child, idx) => {
              Object.keys(child).forEach(childKey => {
                if (typeof (context.formValidation[key].elements[idx][childKey].warning) === 'function' && this.formValidation[key].elements[idx][childKey].warning(idx)) {
                  context.formValidation[key].elements[idx][childKey].isWarning = true
                  context.highlight(childKey, true, idx)
                  if(context.formValidation[key].elements[idx][childKey].attentionWarning) {
                    context.attentionWaringStatus = true
                  }else{
                    context.hasWarning = true
                  }
                } else if (typeof (context.formValidation[key].elements[idx][childKey].warning) !== 'function'
                  && (context[key][idx][childKey] === null || context[key][idx][childKey] === undefined
                  || context[key][idx][childKey] === '' || context[key][idx][childKey] === false
                  || context[key][idx][childKey] === '　')) {
                  context.formValidation[key].elements[idx][childKey].isWarning = true
                  context.highlight(childKey, true, idx)
                  context.hasWarning = true
                } else {
                  context.formValidation[key].elements[idx][childKey].isWarning = false
                  context.highlight(childKey, false, idx)
                }
              })
            })
          } else if (typeof (this.formValidation[key].warning) === 'function' && this.formValidation[key].warning()) {
            this.formValidation[key].isWarning = true
            this.highlight(key)
            if(this.formValidation[key].attentionWarning) {
              this.attentionWaringStatus = true
            }else{
              this.hasWarning = true
            }
          } else if (typeof (this.formValidation[key].warning) !== 'function' && this.formValidation[key].warning
            && (this[key] === null || this[key] === undefined || this[key] === '' || this[key] === false || this[key] === '　')) {
            this.formValidation[key].isWarning = true
            this.highlight(key)
            this.hasWarning = true
          } else {
            this.highlight(key, false)
          }
        }
      })
      this.checkValidate = true
      return this.hasWarning
    },
    validateError() {
      let hasError = false
      const filterErrorKeys = Object.keys(this.formValidation).filter(key => this.formValidation[key].error)
      filterErrorKeys.forEach(key => {
        if (this.formValidation[key].error()) {
          this.formValidation[key].isError = true
          hasError = true
        } else {
          this.formValidation[key].isError = false
        }
      })
      this.checkValidate = true
      return hasError
    },
    async checkSave() {
      const hasError = await this.validateError()
      if (hasError) {
        this.popupFormError = true
        return false
      }
      await this.validateWarning()
      if(this.hasWarning && this.attentionWaringStatus) {
        this.messageWhenHanei = MESSAGE.M1019
      } else if(this.hasWarning) {
        this.messageWhenHanei = MESSAGE.M1017
      } else if(this.attentionWaringStatus) {
        this.messageWhenHanei = MESSAGE.M1018
      } else {
        this.messageWhenHanei = MESSAGE.M1007
      }
      this.popupActiveSaveForm = true
    },
    lostFocus() {
      if (this.checkValidate === true) {
        setTimeout(() => {
          this.validateError()
          this.validateWarning()
        }, 20)
      }
    },
    tickPart(partName) {
      console.log(partName)
    },
    focusOut() {
      this.currentFocus = 0
      this.lostFocus()
    },

    handleShowHightlightInPage(highlight) {
      const isIdGeneral1 = idBaikeiGeneralComment_l1.includes(highlight)
      if(isIdGeneral1) {
        highlight = highlight.substring(0, 7) +  (parseInt(highlight.substring(7)) - 1).toString()
      }
      const idHightlighted = this.arrayHighlightId
      this.handleShowHightlightInPageMixin(highlight, idHightlighted)
    },
    handleCloseCommentSiderPage() {
      const div = document.getElementById('closeCommentSiderPattern')
      if (div.style.display !== 'none') {
        div.style.display = 'none'
      }
    },
    setselectUrinushishomei(index) {
      this.lostFocus()
      if(this.urinushishomeiInputs[index].urinushi_type !== 'その他フリーワード') {
        this.urinushishomeiInputs[index].sonohoka_type = ''
      }
    },
    setselectKainushishomei(index) {
      this.lostFocus()
      if(this.kainushishomeiInputs[index].kainushi_type !== 'その他フリーワード') {
        this.kainushishomeiInputs[index].sonohoka_type = ''
      }
    },
    handleAddIndexUrinushi() {
      this.urinushishomeiInputsIndex = []
      let count = 1
      this.urinushishomeiInputsIndex = this.urinushishomeiInputs.map((item) => {
        if(item.urinushi_type === '売主') {
          return ++count
        }else{
          return null
        }
      })
    },
    handleAddIndexKainushi() {
      this.kainushishomeiInputsIndex = []
      let count = 1
      this.kainushishomeiInputsIndex = this.kainushishomeiInputs.map((item) => {
        if(item.kainushi_type === '買主') {
          return ++count
        }else{
          return null
        }
      })
    }
  }
}
</script>

<style scoped>
#BSC {
  word-wrap: break-word;
  display: flex;
  font-weight: bold;
}

.preview {
  width: 400px;
  height: 600px;
}

.background-style {
  background-color: white;
  padding: 10px;
  border: 2px solid #eeeeee;
  border-radius: 5px;
}

.input1-width {
  width: 50px;
}

.is-error /deep/ span.vs-radio--borde{
  border-color: red !important
}

.input2-width {
  width: 90px;
}

.sytle-button {
  display: flex;
  justify-content: flex-end;
  margin: 30px;
  gap: 30px;
  position: fixed;
  z-index: 1;
  background: #f8f8f8;
  padding: 9px 30px 7.5px;
  border-radius: 4px;
  right: 3px;
  width: calc((100% - 260px) - 6px);
  margin: 0px;
  bottom: 3px;
  border: 1px solid #dddddd;
  box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 15%);
}

table th {
  width: 130px;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
.btn-positive {
  border: 1px solid #7367F0;
}
.input-warning /deep/ input {
  background-color: rgba(255, 197, 54, 0.6) !important;
}
.input-warning-area /deep/ textarea {
  background-color: rgba(255, 197, 54, 0.6) !important;
}
.v-select-bsc {
  height: fit-content;
}
.v-select-bsc /deep/ .vs__dropdown-toggle {
  background-color: #fff !important;
}
.v-select-bsc /deep/ .feather {
  stroke: #6e6e6e !important;
}
.border-none {
  border: none !important;
}
.border-top-none {
  border-top: none !important;
}
.border-right-none {
  border-right: none !important;
}
.border-left-none {
  border-left: none !important;
}
.border-bottom-none {
  border-bottom: none !important;
}

.table-border-left-right {
  border-left: 1px solid #dddddd;
  border-right: 1px solid #dddddd;
}
.baikei-transition-enter-active {
  transition: all 0.25s ease-out;
}

.baikei-transition-leave-active {
  transition: all 0.25s ease-in;
}

.baikei-transition-enter,
.baikei-transition-leave-to {
  transform: translateX(-50px);
  opacity: 0;
  width: 0% !important;
}
.flex-grow-width-make {
  flex-grow: 1;
  flex-basis: 57%;
  min-width: 57%;
}
.preview-edit-screen {
  overflow: scroll;
  height: 615px;
  margin-top: 0.75rem;
}

.comment-frame {
  overflow: scroll;
  height: 615px;
  margin-top: 0.75rem;
}
.w-57 {
  width: 57%;
}
.w-65 {
  width: 65%;
}
.w-706 {
  width: 70.6%;
}

.mr-18 {
  margin-right: 1.8rem;
}
.w-1595px {
  width: 159.5px;
}
.max-w-120 {
  max-width: 120px;
}
</style>
